
/**
 * Core JavaScript functionality.  Provides wrappers / shorthand for many common JavaScript programming needs,
 * and many of the functions in the api provide additional optimization, or debugging improvements.
 * This module is intended to be the base / required module for pretty much every piece of modularized JS code
 * going forward.
 *
 * @name {Object} fitt
 * @namespace
 * @public
*/

var fitt;

fitt = fitt || function () {


	/*
                             * Modules should start with variable/constant declaration / initialization
                             * for items that have no dependancies.  All functions, including module
                             * definitions should always have only 1 single var statement, with each
                             * variable initiliazation/declaration seperated by commma.  In other
                             * words, 1 function should only have 1 single var statement and optionally
                             * 1 single const statement (if we are allowing new school syntax).
                             *
                             * let statements are allowed in blocks, as per their use-case, but there
                             * should NOT be const or var statements interspersed throughout blocks
                             * of a function
                            */

	/*
                                * Shorthand constants, which we will expose out of the module as well.
                                * (See documentation below).  A great number of property / method names
                                * in JavaScript and the DOM are rather long in terms of number of characters
                                * and so we have variables/constants defined to allow us to make the code
                                * size much smaller.  Client-side, this can reduce overall code size by
                                * as much as 20% depending on how other code is written.
                               */

	/*
                                   * Constants are always ALL CAPS, word seperation done with '_'
                                  */

	var PROTO = "prototype",
	UPROTO = "__proto__",
	CONSTRUCT = "constructor",
	TO_STR = "toString",
	VALUE = "value",
	VALUE_OF = VALUE + "Of",
	TYPE_STR = "string",
	TYPE_NUM = "number",
	TYPE_BOOL = "boolean",
	TYPE_FUNC = "function",
	TYPE_OBJ = "object",
	TYPE_SYM = "symbol",
	TYPE_UNDEF = "undefined",
	TYPE_UNKNOWN = "unknown", /* legacy IE 9 and below */
	CAN_CONF = "configurable",
	CAN_WRITE = "writable",
	CAN_ENUM = "enumerable",
	DEF_GET = "__defineGetter__",
	DEF_SET = "__defineSetter__",
	NULL = null,
	UNDEF = void 0,
	TRUE = true,
	FALSE = false,
	NEG_ONE = -1,
	RETURN = "return",
	WIN = "window",
	GLOBAL = "global",

	/* Shorthand dereferenced module variables */

	/*
                                                * Shorthand deferenced static members (properties / methods)
                                                * should use the same name as the dereferenced shorthand variable
                                                * name seperated by an '_'
                                               */

	/*
                                                   * Next in modules should be any variables that are declared
                                                   * or initialized via dependencies
                                                  */
	obj = Object,
	obj_assign = obj.assign,
	obj_create = obj.create,
	obj_cprop = obj.defineProperty,
	obj_gprop = obj.getOwnPropertyDescriptor,
	obj_props = obj.getOwnPropertyNames,
	obj_syms = obj.getOwnPropertySymbols,
	obj_keys = obj.keys,
	obj_getProto = obj.getPrototypeOf,
	obj_setProto = obj.setPrototypeOf,
	obj_noExtend = obj.preventExtensions,
	obj_canExtend = obj.isExtensible,
	obj_seal = obj.seal,
	obj_freeze = obj.freeze,
	obj_sealed = obj.isSealed,
	obj_frozen = obj.isFrozen,

	/*
                             * Shorthand deferenced members from a prototype object
                             * use a prefix of '$' to reference the function / class from
                             * which the prototype object lives, and short hand deferenced
                             * variables for members of that prototype follow the same pattern
                             * of '_' to seperate the owning object, and then a member.
                             *
                             * For example:
                             *      var obj             = Object;
                             *
                             *      var obj_assign      = obj.assign;  //where obj is the owning reference _assign means the property 'assign'
                             *                                         //on the obj variable.
                            */
	$obj = obj[PROTO],
	$obj_owns = $obj.hasOwnProperty,
	$obj_toString = $obj.toString,
	$obj_kindOf = $obj.isPrototypeOf,

	ary = Array,
	$ary = ary[PROTO],
	$ary_slice = $ary.slice,
	$ary_join = $ary.join,
	$ary_strTag = toStringTag.call([]),
	$ary_forEach = $ary.forEach,
	func = Function,
	$func = func[PROTO],
	str = String,
	$str = str[PROTO],
	$str_trim = $str.trim,
	strArrayAccess = FALSE,

	regx = RegExp,
	$regx = regx[PROTO],
	$regx_strTag = toStringTag(/\s/),
	$regx_test = $regx.test,

	dte = Date,
	$dte = dte[PROTO],
	$dte_strTag = toStringTag(new dte()),

	num = Number,
	$num = num[PROTO],

	err = Error,
	$err = err[PROTO],

	jsn = typeof JSON === TYPE_OBJ && JSON,
	jsnParse = jsn && jsn.parse,
	jsnStringify = jsn && jsn.stringify,

	/* Shorthand Constants (with dependencies on shorthand dereferenced items */

	/*
                                                                               * Next in modules should be any constants that are declared
                                                                               * or initialized via dependencies
                                                                              */

	NUM_MAX = num && num.MAX_VALUE || 9007199254740992,
	NUM_MIN = NEG_ONE * NUM_MAX,
	NAN = num.NaN,

	/*
                 * The last variables in modules should be state related things
                 *
                */

	ECMAScript5 = typeof obj_create === TYPE_FUNC && typeof obj_props === TYPE_FUNC,
	PropDescErrProto = err(),
	PropDescErr_ERRS,


	/**
                    * Holds a map of global variable names to functions
                    * you can use to get at a given global variable safely
                    * without having to write your own typeof / window. checks
                    *
                    * @name fitt-globalVarNameCache
                    * @private
                    * @static
                    * @type {Object}
                   */
	globalVarNameCache = {},

	exp = {};

	/*
            * After variable declarion, is function declarations, which should ALL be named functions
            *
            * Adding to the prototype property of functions to set them up for being used as constructors
            * or adding static properties to said functions right after the definition is acceptable practice
           */

	/**
               * Basic empty function
               *
               * @name fitt.noop
               * @memberof fitt
               * @function
               * @public
               * @return void
               *
              */

	function noop() {}

	/**
                        * Basic function returning the value true
                        *
                        * @name fitt.passThru
                        * @memberof fitt
                        * @function
                        * @public
                     * @param {any} [o=undefined] param to be returned
                        * @return {any} param passed in
                       */

	function passThru(o) {return o;}

	/**
                                   * Basic function returning the value true
                                   *
                                   * @name fitt.rtrue
                                   * @memberof fitt
                                   * @function
                                   * @public
                                   * @return {Boolean} true
                                  */

	function rtrue() {return TRUE;}

	/**
                                  * Basic function returning the value false
                                  *
                                  * @name fitt.rfalse
                                  * @function
                                  * @public
                                  * @return {Boolean} false
                                 */

	function rfalse() {return FALSE;}

	/**
                                    * Basic function returing the value null
                                    *
                                    * @name fitt.rnull
                                    * @function
                                    * @public
                                    * @return {Null} null
                                   */

	function rnull() {return NULL;}

	/**
                                  * Basic function returning the value 0
                                  *
                                  * @name fitt.rzero
                                  * @function
                                  * @public
                                  * @return {Number} 0
                                 */

	function rzero() {return 0;}

	/**
                               * Basic function for returning the value 1 or -1
                               *
                               * @name fitt.rone
                               * @function
                               * @public
                               * @param {Boolean} [n=false] If true return -1, instead of 1
                               * @return {Number}
                              */

	function rone(n) {return n ? -1 : 1;}


	/**
                                        * Checks to see if a given object is actually an Array
                                        * Array objects from different realms/frames/windows will
                                        * return true.  However objects which inherit from Array or
                                        * objects that are iterable lists like collections or other dom
                                        * objects are not considered arrays (although are considered array like)
                                        *
                                        * @name fitt.isAry
                                        * @function
                                        * @public
                                        * @param {Object} o The object to inspect
                                        * @param {Boolean} [loose=false] Array objects will return true from this function, by default.
                                        *                               Passing true allows inherited / sub-classed objects (like MobX Observable Arrays) to be accepted
                                        * @return {Boolean} true is the object is a pure JavaScript Array object.
                                       */

	function isAry(o, loose) {

		return !loose ? o && (o[CONSTRUCT] == ary || toStringTag(o) == $ary_strTag) :
		o && typeof o == TYPE_OBJ && typeof o.slice == TYPE_FUNC && typeof o.push == TYPE_FUNC && typeof o.join == TYPE_FUNC && 'length' in o;
	}

	/**
    * Checks to see if a given object is actually a RegExp object.
    * Objects from different realms/frames/windows will return true
    *
    * @name fitt.isRegX
    * @function
    * @public
    * @param {Object} o The object to inpsect
    * @return {Boolean} true if the object is a pure JavaScript RegExp object
   */

	function isRegX(o)
	{
		return o && (o[CONSTRUCT] == regx || toStringTag(o) == $regx_strTag);
	}

	/**
    * Checks to see if a given object is either an array or behaves like
    * an array, meaning it has numerical index properties and a length property.
    * Note that empty collections / objects cannot be completely tested for said
    * functionality since they may be read-only or some sort of exotic object,
    * hence why this function returns a numeric value as opposed to a boolean.
    *
    * @name fitt.isAryLike
    * @function
    * @public
    * @param {Object} o The object to inspect
    * @param {Boolean} [ots=false]  Pass true if you are 100% postive the 1st argument is an object, which provides a slight
    *								 performance gain since this function will not then test to ensure the 1st arg is an object on it's
    *								 own
    *
    * @return {Number} returns 0 if not array like, 1 if is array like, -1 if the object appears to have a 0 length and therefore we're not sure
    *
   */

	function isAryLike(o, ots)
	{
		var ret = 0,
		cnt = 0;

		if (isAry(o, TRUE)) {
			ret = 1;
		} else if (ots || typeof o == TYPE_OBJ && "length" in o) {
			/* if it has length of at least 1 and the 0 index shows up as
                                                             * a prop then we can trust it can be indexed over, otherwise
                                                             * we cannot truly trust when there are no items since we don't
                                                             * know if adding a new indexed property will also add the length
                                                             * etc.
                                                            */

			cnt = o.length;
			if (cnt && "0" in o) {
				ret = 1;
			} else {
				ret = NEG_ONE;
			}
		}
		return ret;
	}

	/**
    * Test if a given reference is a function
    *
    * @name fitt.isFunc
    * @function
    * @public
    * @param {*} o A reference to anything
    * @return {Boolean} whether or not the given argument is a function
    *
   */

	function isFunc(o)
	{
		return o && typeof o == TYPE_FUNC;
	}

	/**
    * Test if a given reference is a type of object
    *
    * @name fitt.isObj
    * @function
    * @public
    * @param {*} o A reference to anything
    * @return {Boolean}
   */

	function isObj(o)
	{
		return o && typeof o == TYPE_OBJ ? TRUE : FALSE;
	}

	/**
    * Test if a given reference is an object or function type, as opposed to some primitive value
    * Good for cases where you want to know that the reference is a complex type since functions
    * are also technically objects.
    *
    * @name fitt.isObjLike
    * @function
    * @public
    * @param {*} A reference to anything
    * @return {Boolean}
   */

	function isObjLike(o)
	{
		var ots = o && typeof o;

		switch (ots) {

			case TYPE_OBJ:
			case TYPE_FUNC:
				return TRUE;}

		return FALSE;
	}

	/**
    * Is the given value a number type and also NOT NaN. In other
    * words is it a usable number.
    *
    * @name fitt.isNum
    * @function
    * @public
    * @param {*} n
    * @return {Boolean}
   */

	function isNum(n)
	{
		return typeof n == TYPE_NUM && !isNaN(n);
	}

	/**
    * Determine if a value is a Date
    *
    * @name fitt.isDate
    * @param {Object} val The value to test
    * @returns {Boolean} True if value is a Date, otherwise false
      */

	function isDate(val) {
		return toStringTag(val) === $dte_strTag;
	}

	/**
    * Returns a string describing the given object type/prototype (e.g. "[object Array]", "[object HTMLElement]" etc.)
    * Note that passing a primitive value to this function is effectively the same as converting
    * the given value to a string.
    *
    * @name fitt.toStringTag
    * @function
    * @public
    * @param {Object} n
    * @return {String}
   */

	function toStringTag(o)
	{
		return $obj_toString.call(o);
	}


	/**
    * A error describing issues when a property is configured on an object
    * improperly
    *
    * @name fitt.PropDescErr
    * @class
    * @public
    * @param {String} [msg]
    * @param {Number} code
    * @property {Number} number
    * @property {String} message
   */

	function PropDescErr(code, msg)
	{
		var me = this;

		/*
                  * Allow construction to occur with out a new operator
                 */
		if (!me || !(me instanceof PropDescErr)) {
			return new PropDescErr(code, msg);
		}

		code = cnum(code, 0, 0, NULL, TRUE);
		if (!(code in PropDescErr_ERRS)) {
			code = 0;
		}

		me.message = PropDescErr_ERRS[code] + cstr(msg);
		me.number = code;

		return me;
	}

	/**
    * An object containing the list of available error codes and their description strings.
    *
    * @name fitt.PropDescErr.ERRS
    * @type {Object}
    * @constant
    * @public
    * @property {String} 0		Invalid target and/or descriptor object
    * @property {String} 100 	Property configuration failed
    * @property {String} 200	Invalid call to DataPropDesc constructor
    * @property {String} 201	DataPropDesc objects cannot have a "get" property
    * @property {String} 202	DataPropDesc objects cannot have a "set" property,
    * @property {String} 300	Invalid call to DynPropDesc constructor,
    * @property {String} 301	DynPropDesc objects cannot have a "writable" property
    * @property {String} 302	DynPropDesc objects cannot have a "value" property
   */

	PropDescErr_ERRS =
	{
		0: "Invalid target and/or descriptor object",
		100: "Property configuration failed",
		200: "Invalid call to DataPropDesc constructor",
		201: 'DataPropDesc objects cannot have a "get" property',
		202: 'DataPropDesc objects cannot have a "set" property',
		300: 'Invalid call to DynPropDesc constructor',
		301: 'DynPropDesc objects cannot have a "writable" property',
		302: 'DynPropDesc objects cannot have a "value" property' };


	/* Make the prototype object of the constructor non-writable */
	cprop(PropDescErr, PROTO, PropDescErrProto, FALSE, FALSE, FALSE);

	/* Make the prototype constructor property non-configurable and non-writable */
	cprop(PropDescErr[PROTO], CONSTRUCT, PropDescErr, FALSE, FALSE, FALSE);

	/* Make the static PropDescErr.ERRS map non-writable and non-configurable */
	cprop(PropDescErr, "ERRS", PropDescErr_ERRS, FALSE, TRUE, FALSE);

	/**
                                                                    * Base class implementation for setting up a descriptor object
                                                                    * for defining properties
                                                                    *
                                                                    * @name fitt.PropDesc
                                                                    * @public
                                                                    * @class
                                                                    * @param {Boolean} [cc=true] Whether or not a property is configurable
                                                                    * @param {Boolean} [ce=true] Whether or not a property is enumerable
                                                                    * @property {Boolean} configurable
                                                                    * @property {Boolean} enumerable
                                                                    *
                                                                   */

	function PropDesc(cc, ce)
	{
		var me = this;

		if (!me || !(me instanceof PropDesc)) {
			return new PropDesc(cc, ce);
		}

		/*
     * if the this pointer already has a configurable or enumerable
     * property, and no corresponding argument is passed in, then
     * use the value from that property
    */

		me[CAN_CONF] = cc == NULL ? CAN_CONF in me ? !!me[CAN_CONF] : TRUE : !!cc;
		me[CAN_ENUM] = ce == NULL ? CAN_ENUM in me ? !!me[CAN_ENUM] : TRUE : !!ce;

		return me;
	}

	cprop(PropDesc, PROTO, PropDesc[PROTO], FALSE, FALSE, FALSE);
	cprop(PropDesc[PROTO], CONSTRUCT, PropDesc, FALSE, FALSE, FALSE);


	/**
                                                                    * Class implementation for creating a data descriptor for an object property
                                                                    *
                                                                    * @name fitt.DataPropDesc
                                                                    * @class
                                                                    * @public
                                                                    * @param {Boolean} [cw=true] Whether or not a property is writable
                                                                    * @param {*} [v=null] The value for a given property
                                                                    * @param {Boolean} [cc=true] Whether or not the property is configurable
                                                                    * @param {Boolean} [ce=true] Whether or not the property is enumerable
                                                                    * @extends fitt.PropDesc
                                                                    * @property {Boolean} configurable
                                                                    * @property {Boolean} writable
                                                                    * @property {Boolean} enumerable
                                                                    * @property {*} value
                                                                    * @throws {fitt.PropDescErr} if the constructed object has a "get" or "set" property defined (meaning you should be using fitt.DynPropDesc),
                                                                    *							 or if this function is not called as a constructor (e.g. DataPropDesc(true,0,false,false) will throw
                                                                    *							 but new DataPropDesc(true,0,false,false) will not).
                                                                   */

	function DataPropDesc(cw, v, cc, ce)
	{
		var me = this;

		if (!me || !(me instanceof DataPropDesc)) {
			throw new PropDescErr(200);
		}

		if ("get" in me) {
			delete me.get;

			if ("get" in me) {
				throw PropDescErr(201);
			}
		}

		if ("set" in me) {
			delete me.set;

			if ("set" in me) {
				throw PropDescErr(202);
			}
		}

		PropDesc.call(me, cc, ce);

		me[CAN_WRITE] = cw == NULL ? CAN_WRITE in me ? !!me[CAN_WRITE] : TRUE : !!cw;
		me[VALUE] = v == NULL ? VALUE in me ? me[VALUE] : NULL : v;

		return me;
	}

	cprop(DataPropDesc, PROTO, new PropDesc(), FALSE, FALSE, FALSE);
	cprop(DataPropDesc[PROTO], CONSTRUCT, DataPropDesc, FALSE, FALSE, FALSE);

	/**
                                                                            * Class implementation for creating a data descriptor for an object property
                                                                            *
                                                                            * @name fitt.DynPropDesc
                                                                            * @class
                                                                            * @public
                                                                            * @param {Function} g Getter function for a given property
                                                                            * @param {Function} [s=null] Setter function for a given propery, pass null or constructing the class with only a single argument results in creating
                                                                            *							  a read only property
                                                                            * @param {Boolean} [cc=true] Whether or not the property is configurable
                                                                            * @param {Boolean} [ce=true] Whether or not the property is enumerable
                                                                            * @extends fitt.PropDesc
                                                                            * @property {Function} get
                                                                            * @property {Function} set
                                                                            * @property {Boolean} configurable
                                                                            * @property {Boolean} enumerable
                                                                            * @throws {fitt.PropDescErr} if the constructed object has a "writable" or "value" property defined (meaning you should be using fitt.DataPropDesc),
                                                                            *							 or if this function is not called as a constructor (e.g. DynPropDesc(function() { return 0 },null,false,false) will throw
                                                                            *							 but new DynPropDesc(function() { return 0 },null,false,false) will not).
                                                                           */

	function DynPropDesc(g, s, cc, ce)
	{
		var me = this;

		if (!me || !(me instanceof DynPropDesc)) {
			throw PropDescErr(300);
		}

		if (CAN_WRITE in me) {
			delete me[CAN_WRITE];

			if (CAN_WRITE in me) {
				throw new PropDescErr(301);
			}
		}

		if (VALUE in me) {
			delete me[VALUE];

			if (VALUE in me) {
				throw new PropDescErr(302);
			}
		}

		PropDesc.call(me, cc, ce);

		me.get = g == NULL ? noop : g;
		me.set = s == NULL ? noop : s;

		return me;
	}

	cprop(DynPropDesc, PROTO, new PropDesc(), FALSE, FALSE, FALSE);
	cprop(DynPropDesc[PROTO], CONSTRUCT, DynPropDesc, FALSE, FALSE, FALSE);


	/**
                                                                          * Construct and object descriptor for defining how a call to mix will behave. Rather than passing {@link fitt.mix} multiple arguments
                                                                          * for said options you can alternatively pass just this object.
                                                                          *
                                                                          * @name fitt.MixOptions
                                                                          * @class
                                                                          * @public
                                                                          * @param {Boolean} [owned=false] Force only copying 'owned' properties from the given supplier.
                                                                          * @param {Boolean} [sourceArrayAsSingle=false] If you pass an array to mix, use it as single source, copying each index into your receiver object when this is set to true.
                                                                          *                                              Otherwise it behaves similar to Object.assign, if you pass an array as the source it will treat each item in the array as it's own source.
                                                                          * @param {Boolean} [skipFuncs=false] If true, don't mix in properties that are functions.
                                                                          * @param {Boolean} [noRecurse=false] If true, do not recurse down into objects, simply treat them as primitive values.
                                                                          * @param {Boolean|Number} [noOverwrite=false] If true, and if the receiver already has a property of the given name, do not set it's value to that of what's in the supplier.
                                                                          * 											   If set to 2, then same logic applies but if the given property in the receiver is an object, allow recursive mixin from the supplier
                                                                          *											   to occur (in other words allows further annotation of an exising object).
                                                                         	 * @param {Boolean} [defProps=false] If true, add the property to the receiver object using Object.defineProperty rather than just doing an implicit define of the property via
                                                                          *                                  a set.  This will be slightly slower, but will allow you to add own properties to objects that have a frozen proto object.
                                                                         	 * @param {Object|Boolean} [altKeys=null]  If argument is true, then we will iterate over the properties in the receiver object, and copy values from the source object.
                                                                          *												    If argument is an object, then only properties from this object will be used it copy values (think of it like a filter object).
                                                                          *													In either case, if there is recursion (which is the default), the same list of properties are copied throughout each level of recursion
                                                                          * @property {Boolean} owned See 'owned' parameter above
                                                                          * @property {Boolean|Number} noOvr See 'noOverwrite' parameter above
                                                                          * @property {Boolean} defProp See 'defProps' parameter above
                                                                          * @property {Boolean} snglSrc See 'sourceArrayAsSingle' parameter above
                                                                          * @property {Boolean} skipFuncs See 'skipFuncs' parameter above
                                                                          * @property {Boolean} noRecurse See 'noRecurse' parameter above
                                                                          *
                                                                            */




	function MixOptions(owned, sourceArrayAsSingle, skipFuncs, noRecurse, noOvr, defProps, altKeys)
	{
		var me = this;

		me.owned = !!owned;
		me.noOvr = noOvr;
		me.defProp = !!defProps;
		me.snglSrc = !!sourceArrayAsSingle;
		me.skipFuncs = !!skipFuncs;
		me.noRecurse = !!noRecurse;
	}

	/**
    * Safely convert any value to a string, and error caught/failure results
    * to convert results in an empty string being returned.
    *
    * Arrays are converted to a string via the join method with NO DELIMITER
    * (making life easier for using arrays as templates / buffers for output).
    * Passing a 2nd argument as a truthy value will forcibly treat that input
    * argument as an array object and call Array.prototype.join using that object
    * as the 'this' pointer
    *
    * Note that false is converted to '', but true is converted to 'true', and 0 is converted to '0'.
    *
    * The main use case is to ensure that you always are dealing with a string primitive
    * and non numeric falsy values such as false, undefined, and null are converted to the
    * falsy string equivalent ('');
    *
    * @name fitt.cstr
    * @function
    * @public
    * @param {*} s, any value / ref to a value to be converted into a primitive string
    * @param {Boolean} [al=false] If true, automatically treat the 1st argument as an array and join it together into a string
    * @return {String} empty string is returned on failure.
    *
   */

	function cstr(s, al)
	{
		var typ = typeof s;

		if (al && s) {
			return $ary_join.call(s, "") || "";
		}

		if (typ == TYPE_STR) return s;
		if (typ == TYPE_NUM) {
			/*
                         	NaN check without calling function if number is not < 0 and not > 0
                         	and does not eq 0 it must be NaN so default
                        */
			if (s === 0) return "0";
			if (isNaN(s)) return "0";

			return s + "";
		}

		if (typ == TYPE_OBJ && s && typeof s.join == TYPE_FUNC) {
			return s.join("");
		}

		if (!s) return "";

		try {
			s = str(s);
		} catch (e) {
			s = "";
		}
		return s;
	}

	/**
    * Get an ordinal value of a number
    * (e.g. 1 -> 1st, 2 -> 2nd etc.)
    *
    * Note that if the 1st parameter passed in does not convert into a positive
    * integer, an empty string is returned.
    *
    * @name fitt.ord
    * @function
    * @public
    * @param {String|Number|Object} val Represents a numeric value to be converted into an ordinal string
    * @param {Boolean} [isnum=false] Pass true to speed thing up a tiny bit avoiding the forced numeric conversion
    *                                of the incoming value
    * @return {String}
      */

	function ord(val, isnum) {
		var n = isnum ? val : cnum(val, 0, 0),
		s = '',
		ret = '',
		j,k;

		if (n > 0) {
			n = Math.round(n);
			j = n % 10;
			k = n % 100;
			if (j === 1 && k !== 11) {
				s = 'st';
			} else if (j === 2 && k !== 12) {
				s = 'nd';
			} else if (j === 3 && k !== 13) {
				s = 'rd';
			} else {
				s = 'th';
			}
			ret = n + s;
		}
		return ret;
	}

	/**
    * Convert a given string (or 1stly convert a given parameter into a string), and then
    * to it's lower case form.  Wrapper for String.prototype.toLowerCase();
    *
    * @name fitt.strlc
    * @function
    * @public
    * @param {*} s Any value / reference to a value
    * @param {Boolean} [ist=false] Set to true if you are sure that the 1st argument is already a string, and conversion is skipped.
    * @return {String}
   */

	function strlc(s, ist)
	{
		s = ist ? s : cstr(s);
		return s.toLowerCase();
	}

	/**
    * Convert a given string (or 1stly convert a given parameter into a string), and then
    * to it's upper case form.  Wrapper for String.prototype.toUpperCase();
    *
    * @name fitt.struc
    * @function
    * @public
    * @param {*} s Any value / reference to a value
    * @param {Boolean} [ist=false] Set to true if you are sure that the 1st argument is already a string, and conversion is skipped.
    * @return {String}
   */

	function struc(s, ist)
	{
		s = ist ? s : cstr(s);
		return s.toUpperCase();
	}


	/**
    * Do a regular expression / string replacement on the given input which generally is a string
    * but this function allows you to pass in any object which will then be converted to a string.
    * Wrapper for String.prototype.replace
    *
    * @name fitt.strReplace
    * @function
    * @public
    * @param {*} s Any value which will be converted into a string if not already.
    * @param {RegExp} ex The regular expression to use for replacing content.  Can also be a string or number but note that you must be careful
    * 					  as such values are then automatically converted into a RegExp object which can lead to unexpected results.
    * @param {String} r  The string to replace within the current string
    * @param {Boolean} [ist=false] Pass true if you are sure the 1st argument is of string type, and this method will skip doing the auto conversion to string type (performance boost).
    * @param {Boolean} [rist=false] Pass true if you are sure the 3rd argument is of string type, and this method will skip doing the auto conversion to string type (performance boost).
    * @return {String}
    *
   */

	function strReplace(s, ex, r, ist, rist)
	{
		s = ist ? s : cstr(s);
		r = rist ? r : cstr(r);
		return s.replace(ex, r);
	}

	/**
    * Do a regular expression match on a string (wrapper for String.prototype.match),
    * but this function allows you to pass in any object which is then converted to a string.
    *
    * @name fitt.strMatch
    * @function
    * @public
    * @param {*} str Any value which will automatically be converted to a string if needed (auto conversion can be disabled by the 4th optional argument).
    * @param {RegExp} The regular expression object to use for match execution.
    * @param {Number} [idx=null] If specified the return value of this function will return the the item returned from a successful match at the given index.
    * @param {Boolean} [its=false] Force treating the 1st argument as a string and do not attempt auto conversion (slight performance boost).
    * @return {Array|null|String} If no idx argument is specified returns the Array like match object or null on failure.  If an idx argument is specified
    *							   returns the item at the given index in the Array like match object or null if nothing found.
    *
   */

	function strMatch(str, regEx, idx, its)
	{
		var m;

		str = its ? str : cstr(str);
		m = str && str.match(regEx);

		return idx == NULL ? m || NULL : m && m[idx] || NULL;
	}

	/**
    * Wrapper for RegExp.prototype.test, returning a boolean true if the
    * given regular expression matches something in the given string
    *
    * @name fitt.regxTest
    * @public
    * @param {RegExp} r A regular expression
    * @param {String} s A string
    * @param {Boolean} [rts=false] If true, first argument is guaranteed to be a RegExp instance (small run time speed improvement)
    * @param {Boolean} [sts=false] If true, 2nd argument is guaranteed to be a string (small run time speed improvement)
    * @return {Boolean}
   */

	function regxTest(r, s, rts, sts)
	{
		s = sts ? s : cstr(s);
		r = rts ? r : r && isRegX(r) ? r : NULL;
		return s && r ? $regx_test.call(r, s) : FALSE;
	}


	/**
    * Wrapper for String.prototype.search, returning a boolean true if the
    * given regular expression matches something in the given string
    *
    * @name fitt.regxSearch
    * @public
    * @param {RegExp} r A regular expression
    * @param {String} s A string
    * @param {Boolean} [rts=false] If true, first argument is guaranteed to be a RegExp instance (small run time speed improvement)
    * @param {Boolean} [sts=false] If true, 2nd argument is guaranteed to be a string (small run time speed improvement)
    * @return {Number} returns -1 if nothing found
   */

	function regxSearch(r, s, rts, sts)
	{
		s = sts ? s : cstr(s);
		r = rts ? r : r && isRegX(r) ? r : NULL;
		return s && r ? s.search(r) : -1;
	}

	/**
    * Safely convert a value into a primitive number type, as well as allowing you to specify a range of values
    * the given number value should fall within.  If the value results in a NaN value or does not fall in the specified
    * ranges, you may also specify a default value to be returned.
    *
    * @name fitt.cnum
    * @function
    * @public
    * @param {*} val Any value to be converted to a number.  Objects will automatically call their valueOf or [Symbol.toPrimitive] functions
    * @param {*} [defVal=null] If specified, this value will be returned when the 1st argument cannot be converted to a valid number or if it does not fall within the given min max ranges.
    * @param {Number} [minVal=Number.MIN_VALUE] If specified the mininum value the number should be.  The default minimum value is equivalent to the Number.MIN_VALUE constant which
    * 											 is approx (-9007199254740992).
    * @param {Number} [maxVal=Number.MAX_VALUE] If specified the maximum value the number should be.  The default maximum value is equivalent to the Number.MAX_VALUE constant which
    * 											 is approx (9007199254740992).
    * @param {Boolean} [ts=false] Do not wrap the attempted numeric value conversion in a try/catch block (small performance boost on some platforms).
    * @return {Number|*}
   */

	function cnum(val, defVal, minVal, maxVal, ts)
	{
		var v = val;

		if (typeof val != TYPE_NUM) {
			if (ts) {
				v = num(val);

				if (isNaN(v)) {
					v = parseFloat(val);
				}
			} else {
				try {
					v = num(val);

					if (isNaN(v)) {
						v = parseFloat(val);
					}
				} catch (e) {
					v = NAN;
				}
			}
		}

		/* Yes we use == here on purpose, as == NULL works for
     * both null and undefined values
    */
		if (maxVal == NULL) maxVal = NUM_MAX;
		if (minVal == NULL) minVal = NUM_MIN;

		return (isNaN(v) || v < minVal || v > maxVal) && defVal != NULL ? defVal : v;
	}

	/**
    * Convert a value into a boolean, parsing certain common strings to be treated as true/false
    * The value is converted to a string if it is an object.
    * Values of "0", "false", "undefined", "null", "no" are all converted to false (normally these would evaluate to true since they are strings with some chars).
    *
    * @name fitt.cbool
    * @function
    * @public
    * @param {*} Any value to convert
    * @return {Boolean}
    *
   */

	function cbool(v)
	{
		var tmp = v,typ = typeof tmp;

		if (tmp && typ == TYPE_OBJ) {
			tmp = strlc(tmp);
			typ = TYPE_STR;
		}

		if (typ == TYPE_STR && tmp === "0" || tmp === "false" || tmp === "no" || tmp === TYPE_UNDEF || tmp === "null") return FALSE;

		return !!tmp;
	}

	/**
    * Create an object, optionally with a specified prototype and set of properties.
    * Essentially a wrapper for Object.create, with 1 difference that the default prototype
    * of this call is null rather than Object.prototype unless you specify some other object.
    *
    * @name fitt.cobj
    * @function
    * @public
    * @param {Object|Function} [p=null] The prototype of the object to created if desired.
    * @param {Object} [d=null] A nested descriptor object, with each key representing the name of a property and each value being an object descriptor
    *							for how the property should be configured.
    * @return {Object}
    *
   */

	/*
       * functions which are dynamically generated should still first be defined
       * inline using a named function declartion, and then re-assigned
      */

	/**@ignore */
	function cobj(p, d) {}

	cobj = function () {

		var fc, f, b;

		if (ECMAScript5) {
			fc = func("c", cstr([RETURN, "(", TYPE_FUNC, " cobj(p, d) { p = p || null; ", RETURN, " (arguments.length > 1) ? c(p, d) : c(p); });"]));
			f = fc(obj_create);
		} else {
			b =
			[
			TYPE_FUNC, " cobj(p, d) {\n",
			"	var f = ", TYPE_FUNC, "(){}, o;\n",
			"	p = p || null;\n",
			"	f.", PROTO, " = p;\n",
			"	o = new f();\n",
			"	if (d) {\n",
			"		cp(o,d);\n",
			"	}\n",
			"	", RETURN, " o;\n",
			"};\n",
			"return cobj;"];

			fc = func("cp", cstr(b));
			f = fc(cprops);
		}

		return f;

	}();

	/**
       * Attempt to convert array-like objects such as regular expression matches, arguments objects, node lists, and so
       * on into a formal JavaScript array object.
       * Defaults to returning an empty array object if a null/undefined input object is passed in or
       * if the given object cannot be converted into an array.
       * Strings are split into an array by each character in the string.
       *
       * @name fitt.cary
       * @function
       * @public
       * @param {*} [o=null] The array like object to use to convert into a formal array.  Pass no arguments, or null to create
       * @param {Number} [n=null] The size of the array to be created, if not used the array's size is determined by the number of items in the given input object
       * @return {Array}
      */

	function cary(o, n)
	{
		var ret = [],otyp,did_ap,len = 0,idx;

		if (o) {
			try {
				otyp = typeof o;

				/* ignore functions, window objects, or node objects */
				if (otyp == TYPE_FUNC || o.top == top || o.nodeType || o.tagName) {
					if (n > 0) {
						ret = new ary(n);
					}
					return ret;
				}

				/* if it's a string, split it to a char array */
				if (otyp == TYPE_STR) {
					ret = o.split("");
					if (n > 0 && ret.length >= n) {
						ret = ret.slice(n);
					}
					return ret;
				}

				/* if it's a non-object return empty array */
				if (otyp != TYPE_OBJ) return ret;

				len = cnum(o.length, NEG_ONE, NULL, NULL, TRUE);
			} catch (e) {
				/* if a failure checking the args just beat it */
				if (n > 0) {
					ret = new ary(n);
				}
				return ret;
			}

			if (len > 0) {
				/* if it's really an Array, just make a new array from the orignal
                    note we use the constructor prop, rather than doing an instanceof
                    b/c we don't want to call Array.prototype.concat on sub-classes of Array
                    since that can produce very odd results.
                 */

				if (isAry(o)) {
					ret = ret.concat(o);
					did_ap = ret.length === len; /* but make sure to check you get the length you expect */
				}

				if (!did_ap) {
					try {
						ret = $ary_slice.call(o);
						did_ap = ret.length === len;
					} catch (e) {
						did_ap = FALSE;
						ret = [];
					}
				}

				if (!did_ap) {
					/*
                   * array apply or concat couldn't be called (say it's old IE and you have a Dom Node List)
                   * so just brute force loop
                  */
					ret = new ary(len);
					for (idx = 0; idx < len; idx++) {
						ret[idx] = o[idx];
					}
				}
			} else if (o && "0" in o) {
				for (idx in o)
				{
					idx = cnum(idx, -1, 0, NULL, NULL, TRUE);
					if (idx >= 0) {
						ret[idx] = o[idx];
					}
				}
			}

			if (n > 0 && ret.length >= n) {
				ret = ret.slice(n);
			}
		}
		return ret;
	}

	/**
    * Ensures that a given function is still valid by checking the global object/realm from
    * which the function reference was created.  If that global / realm no longer exists
    * than the function is no longer valid / truly callable in a safe way.  Especially
    * useful in cases where you have a function handle from an IFrame or shared worker,
    * where that context/global/realm can be dynamically removed.
    *
    * @name fitt.canCall
    * @function
    * @public
    * @param {Function} f A function reference
    * @return {Boolean}
    *
   */

	function canCall(f)
	{
		var isOK = FALSE,
		o;

		try {
			if (f && typeof f == TYPE_FUNC) {
				if (f instanceof func) {
					isOK = TRUE;
				} else {
					o = f.toString();
					if (o) {
						o = f[CONSTRUCT]("return window || global;");
						isOK = !!(o && (o.top || o.global));
					}
				}
			}
		} catch (e) {
			isOK = FALSE;
		}

		o = f = NULL;
		return isOK;
	}

	/**
   * Similar to native JavaScript call/apply functions except that it first
   * checks to make sure that the function reference is still valid and
   * that it wraps the call to said function in a try / catch block
   *
   * If an error is caught by default it is swallowed, allowing your
   * program to continue.  To retrieve information about said error
   * pass in a info object as the 3rd argument.
   *
   * @name fitt.callSafe
   * @function
   * @param {Function} f A reference to a function to be called
   * @param {Object} [thisPointer] An object to be used as the this pointer for the function call. Must be a native JS object
   * @param {Object} [info] Pass in an empty object to be used an output parameter for discovering information about the function call. This object will contain at least 2 properties "time" which is the number
   *                        of milliseconds that the function took and "err" which is the error object that was caught if any
   * @param {...Mixed} func_args Any additional arguments will be passed directly to said function. Note that passing in only one extra argument that is an array, that array will be treated as the argument list
   *
   * @return return value of the function called
   *
   */

	function callSafe(f, thisPointer, info /* additional args */)
	{
		var ret,err,args = arguments,arg_cnt = args.length,idx = 3,new_arg_list = [],start = 0,end = 0;

		if (canCall(f)) {
			if (arg_cnt > idx) new_arg_list = cary(args, idx);

			thisPointer = thisPointer || NULL;

			if (info) {
				start = new dte();
				try {
					ret = f.apply(thisPointer, new_arg_list);
				} catch (e) {
					err = e;
				}
				end = new dte();
			} else {
				/* if no info object is provided then there is no reason to construct
            * date objects
           */
				try {
					ret = f.apply(thisPointer, new_arg_list);
				} catch (e) {
					err = e;
				}
			}
		} else {
			err = new Error("bad ref");
			err[TYPE_NUM] = -2147418113;
		}

		if (info) {
			try {
				info.time = end - start;
				info.err = err || NULL;
			} catch (e) {}
		}

		return ret;
	}


	/**
    * Define/redefine a property on a given object, handling edge cases for IE 8,
    * and returning a boolean indicating whether or not the property was defined
    * on the object properly.
    *
    * Automatically checks the object's current properties to ensure configuration
    * can occur and creates the descriptor object for you.
    *
    * Effectively this is an alias for Object.defineProperty with fallback logic
    * in case ECMAScript 5 is not supported.
    *
    * @name fitt.cprop
    * @function
    * @public
    * @param {Object|Function} o The object on which to configure/re-configure a property
    * @param {String} pn The property name
    * @param {*} [v=null] The value of the property to be used if the given property is to be setup as a static property (as in no getter / setter)
    * @param {Boolean} [cr=true] Whether or not the given property should be re-configurable or deletable
    * @param {Boolean} [ce=true] Whether or not the given should be enumerable (shows up in for/in loops, or Object.keys).
    * @param {Boolean} [cw=null] Whether or not the given property is writable, assuming it is a static property (use null if the property has getters/setters)
    * @param {Function} [cg=null] A function used as a getter to retrieve the property value, use null for static/data properties
    * @param {Function} [cs=null] A function used as a setter to set the value of the property on the object.
    * @param {Boolean} [nfbk=false] If true, and property configuration fails, do not attempt a simple set of an own property. By default, this function
    * 								 will do that for fallback cases of non-ECMAScript 5 compliance (like say IE7), which will both set and create a property
    * @return {Boolean} true if the property was configured with your settings
   */

	function cprop(o, pn, v, cr, ce, cw, cg, cs, nfbk)
	{
		var didIt = FALSE,
		sentGetter = FALSE,
		sentSetter = FALSE,
		objType = o && typeof o || "",
		getFunc,setFunc,desc,newDesc,tempFunc;

		if (cg && canCall(cg)) {
			sentGetter = TRUE;
			getFunc = cg;
		} else {
			tempFunc = func("v", cstr([RETURN, " (", TYPE_FUNC, "() { ", RETURN, " v; }); "]));
			getFunc = tempFunc(v);
			tempFunc = NULL;
		}

		if (cs && canCall(cs)) {
			sentSetter = TRUE;
			setFunc = cs;
		} else {
			setFunc = noop;
		}

		if (sentSetter && !sentGetter) getFunc = noop;

		if (obj_cprop && (objType == TYPE_OBJ || objType == TYPE_FUNC)) {
			/*
                                                                    * IE 8 doesn't like you to use writable in some cases
                                                                    * so just automatically use getter/setter mode
                                                                    * above we have automatically created a getter / setter
                                                                    * for the given value if needed
                                                                    *
                                                                    * IE 8 has no Object.create method
                                                                   */

			if (sentGetter || sentSetter || !ECMAScript5) {
				newDesc = new DynPropDesc(getFunc, setFunc, cr, ce);
			} else {
				newDesc = new DataPropDesc(cw, v, cr, ce);
			}

			/*
      * IE 8 doesn't like configurable or enumerable to be set
      * IE 8 doesn't have Object.create method
     */

			if (!ECMAScript5) {
				newDesc[CAN_CONF] =
				newDesc[CAN_ENUM] = TRUE;
			}
		}

		if (obj_gprop) {
			desc = obj_gprop(o, pn);
		}

		if (obj_cprop) {
			if (!desc) {
				obj_cprop(o, pn, newDesc);
				didIt = TRUE;
			} else if (!desc[CAN_CONF] && desc[CAN_WRITE]) {
				/* even if something is not configurable, if it's writeable, you're still
                                                    * allowed to lock / change writeable down to false
                                                   */

				newDesc[CAN_CONF] = desc[CAN_CONF];
				newDesc[CAN_ENUM] = desc[CAN_ENUM];

				if (newDesc.get) delete newDesc.get;
				if (newDesc.set) delete newDesc.set;

				if (!(CAN_WRITE in newDesc)) {
					newDesc[CAN_WRITE] = setFunc == noop ? FALSE : !!cw;
				}

				if (!(VALUE in newDesc)) {
					newDesc[VALUE] = v;
				}

				obj_cprop(o, pn, newDesc);

				didIt = TRUE;

			} else {
				try {
					obj_cprop(o, pn, newDesc);
					didIt = TRUE;
				} catch (e) {
					didIt = FALSE;
				}
			}
		}

		if (didIt) {
			try {
				didIt = o[pn] === v;
			} catch (e) {
				didIt = FALSE;
			}
		}

		try {
			if (didIt === FALSE && o[DEF_GET]) {
				o[DEF_GET](pn, getFunc);
				o[DEF_SET](pn, setFunc);
				didIt = o[pn] === v;
			}
		} catch (e) {
			didIt = FALSE;
		}

		if (!nfbk && !didIt) {
			try {
				o[pn] = v;
				didIt = o[pn] === v;
			} catch (e) {
				didIt = FALSE;
			}
		}

		return didIt;
	}

	/**
    * Private method called by {@link fitt.inherits} that tags each function
    * so that we can tell what methods were part of a 'class' at the time of inheritance
    *
    * @name fitt-inherits_forEachClassMethod
    * @function
    * @private
    * @param {*} func The property value on a function prototype
    * @param {String} name The name of the property on that prototype
    *
   */

	function inherits_forEachClassMethod(func, name)
	{
		if (typeof func === TYPE_FUNC && !owns(func, '_methodName')) {
			func._methodName = name;
		}
	}


	/**
    * Private getter function used to retrieve the 'super' version of a calling function / method on
    * an object.  Note that this does indeed rely on Function.prototype.caller, b/c it's ES5
    * but until we can use ES6 classes in browsers directly, this is the only way.
    * (It does however make that call safely)
    *
    * @name fitt-inherits_getSuper
    * @function
    * @private
    * @return {Function}
    * @throws {Error} if the target is not an object or if the given caller cannot be found.
   */

	function inherits_getSuper(funcToFind)
	{
		var me = this,
		name = funcToFind && funcToFind._methodName,
		foundCaller = false,
		proto = me,
		impl;

		if (!isObjLike(me)) {throw new err('invalid target object');}

		if (name) {
			while ((proto = obj_getProto(proto)) && !impl) {
				if (!proto[name]) {
					break; // no implementation here
				} else if (proto[name] === funcToFind) {
					foundCaller = true; // found the function we are calling from
				} else if (foundCaller) {
					impl = proto[name]; // we've already passed our calling function in the chain, so we must be at correct implementation
				}
			}
		}

		if (!impl) {throw new err('super implementation not found');}

		return function () {
			return impl.apply(me, arguments);
		};
	}

	/**
    * Inherit the prototype methods from one constructor into another.
    *
    * @name fitt.inherits
    * @function
    * @param  {Function} C Child constructor
    * @param  {Function} P Parent constructor
    *
    */
	function inherits(C, P) {

		var CProto = C[PROTO] = mix(cobj(P[PROTO]), C[PROTO]);

		C.parent = P[PROTO];

		/** @override */
		CProto[CONSTRUCT] = C;

		forEach(CProto, inherits_forEachClassMethod);

		// Define a special `super` property that locates the super implementation of the caller

		cprop(CProto, 'super', inherits_getSuper, FALSE, FALSE, FALSE, NULL, NULL, TRUE);

	};

	/**
     * Performs equality by iterating through keys on an object and returning false
     * when any key has values which are not strictly equal between the arguments.
     * Returns true when the values of all keys are strictly equal.
     *
     * @name fitt.shallowEq
     * @function
     * @public
     * @param {Object} A The first object
     * @param {Object} B The second object
     * @return {Boolean} true when the values of all keys are strictly equal
     */

	function shallowEq(A, B) {
		var i, keysA, keysB, typeA, typeB, keysALen, valA, valB, key;

		if (A === B) {
			return TRUE;
		}

		typeA = typeof A;
		typeB = typeof B;

		if (typeA !== typeB || A === NULL || B === NULL) {
			return FALSE;
		}

		if (
		typeA === TYPE_NUM && typeB === TYPE_NUM &&
		A !== A && B !== B)
		{
			return TRUE;
		}

		keysA = keys(A);
		keysB = keys(B);

		keysALen = keysA.length;

		if (keysALen !== keysB.length) {
			return FALSE;
		}

		for (i = 0; i < keysALen; i++) {
			key = keysA[i];
			valA = A[key];
			valB = B[key];

			if (
			!owns(B, key) ||
			!(valA === valB ||

			typeof valA === TYPE_NUM && typeof valB === TYPE_NUM &&
			valA !== valA && valB !== valB))


			{
				return FALSE;
			}
		}

		return TRUE;
	};

	/**
     * Define multiple properties on an object at once.  Effectively an alias for Object.defineProperties,
     * but will fallback in situations where ECMAScript 5 features are not available.
     *
     * See {@link fitt.cprop}
     *
     * @name fitt.cprops
     * @function
     * @public
     * @param {Object|Function} o An object on which to define properties
     * @param {Object} d A descriptor object with string keys one for each property to be configured,
     * 					 where the string key is used as the property name and the value is also an object
     *					 which is a descriptor for how the property should be configured.
     * @param {Boolean} [noerr=false] Pass true to continue configuring properties if one given property fails to configure rather than throwing an error
     *
     * @throws {PropDescErr} if one of the given property names in the descriptor cannot be configured, or if no properties are found in the descriptor object
    */

	function cprops(o, d, noerr)
	{
		var propNames,propName,propDesc,idx = 0,cnt;

		if (!isObjLike(o) || !isObj(d) || empty(d)) {
			throw PropDescErr();
		}

		propNames = keys(d);
		cnt = propNames && propNames.length || 0;

		for (; idx < cnt; idx++) {
			propName = propNames[idx];
			propDesc = o[propName];

			if (!cprop(o, propName, NULL, propDesc[CAN_CONF], propDesc[CAN_ENUM], propDesc[CAN_WRITE], propDesc.get, propDesc.set)) {

				if (noerr) continue;

				throw PropDescErr(100);
			}
		}
	}

	/**
   * Iterate over an Array or an Object invoking a function for each item.
   *
   * If `obj` is an Array callback will be called passing
   * the value, index, and complete array for each item.
   *
   * If 'obj' is an Object callback will be called passing
   * the value, key, and complete object for each property.
   *
   * @name fitt.forEach
   * @function
   * @static
   * @public
   * @param {Object|Array} obj The object to iterate
   * @param {Function} fn The callback to invoke for each item
   */

	function forEach(obj, fn)
	{
		var isLikeAry = FALSE,
		idx = 0,
		len = 0,
		objKeys,prop;

		// Don't bother if no value provided
		if (!isObjLike(obj)) {
			fn = obj = NULL;
			return;
		}

		isLikeAry = isAryLike(obj);

		// Force an array if not already something iterable
		if (!isObj(obj) && !isLikeAry) {
			isLikeAry = TRUE;
			obj = [obj];
		}

		if (isLikeAry) {
			if ($ary_forEach) {
				$ary_forEach.call(obj, fn);
			} else {
				// Iterate over array values
				for (len = obj.length; idx < len; idx++) {
					fn(obj[idx], idx, obj);
				}
			}
		} else {
			objKeys = keys(obj);
			len = objKeys && objKeys.length || 0;
			/* we can't use a while loop dense assignment loop
                                          * construct b/c it is possible to get a key that's an empty
                                          * string
                                         */
			for (idx = 0; idx < len; idx++) {
				prop = objKeys[idx];
				fn(obj[prop], prop, obj);
			}
		}

		obj = fn = NULL;
	}

	/**
    * A helper function for running the logic for mixing properties of objects.
    * Completely private, called when {@link fitt.mix} is called while iterating over objects
    *
    * @name fitt-mix_loopLogic
    * @function
    * @private
    * @param {Object} r The object to mix properties into (receiver object).
    * @param {Object} s The object which supplies the values (and property names) for the r parameter.
    * @param {Object} u Alternate filter object, which if specified is used to determine the property names that will be added to the r parameter.
    *					 Not used directly in this function, but passed back to the iteration function
    * @param {String} p The property name being added to the r parameter (receiver object).
    * @param {Boolean} [wantsMerge=false] If the receiver object already has a property of the given name and it's an object, do not overwrite the object
    *									   value said receiver object, but instead, copy/mixin properties into that object.  Requires recursion be on as well
    *									   (noRecurse=false which is the default).
    * @param {Boolean} [skipFuncs=false] Do not add properties to the object which are functions
    * @param {Boolean|Number} [noOverwrite=false] If true, and if the receiver already has a property of the given name, do not set it's value to that of what's in the supplier.
    * 											   If set to 2, then same logic applies but if the given property in the receiver is an object, allow recursive mixin from the supplier
    *											   to occur (in other words allows further annotation of an exising object).
    * @param {Boolean} [noRecurse=false] If true, do not recurse down into objects, simply treat them as primitive values.
    * @param {Function} recFunc The iteration function to call after the copy/add of a given property into the receiver is complete.
    * @param {Boolean} [defprop=false] If true, add the property to the receiver object using Object.defineProperty rather than just doing an implicit define of the property via
    *                                  a set.  This will be slightly slower, but will allow you to add own properties to objects that have a frozen proto object.
    * @return {Object} The r parameter is returned after mix completion.
   */


	function mix_loopLogic(r, s, u, p, wantsMerge, skipFuncs, noOverwrite, noRecurse, recFunc, defprop, usingAltKeys, keepArrays)
	{
		"use strict";
		var has_prop, shas_prop, item, typ, objTyp, cont, rpropType, subItem, newItem, o;


		item = s[p];
		typ = typeof item;
		objTyp = typ === TYPE_OBJ;

		if (skipFuncs && typ === TYPE_FUNC) return;

		has_prop = p in r;
		shas_prop = p in s;
		rpropType = has_prop ? typeof r[p] : TYPE_UNDEF;

		/*
                                                    * noOverwrite 2 means that we don't overwrite the property in the receiving
                                                    * object itself but we will merge properties from the supplier into
                                                    * the receiver, so we set the continue flag to true if the receiver
                                                    * property is an object and user wants merging + recursion
                                                    * other wise if no_ovr is truthy and receiver has the prop, skip
                                                   */

		if (wantsMerge) {
			cont = !has_prop || rpropType === TYPE_OBJ || rpropType === TYPE_FUNC;
		} else {
			cont = has_prop ? !noOverwrite : TRUE;
		}

		if (!cont) return;
		if (!shas_prop && usingAltKeys) return;


		if (!objTyp) {
			if (defprop) {
				cprop(r, p, item, TRUE, TRUE, TRUE);
			} else {
				r[p] = item;
			}
		} else {
			if (item) {
				if (has_prop) {
					if (noOverwrite) {
						if (wantsMerge) {
							o = r[p];
							if (o && typeof o === TYPE_OBJ) {
								recFunc(o, item, item, skipFuncs, noOverwrite, noRecurse, defprop, usingAltKeys, keepArrays);
							}
							return;
						}
					}
				}
				if (!noRecurse) {
					newItem = keepArrays && isAryLike(item) ? [] : {};
					if (defprop) {
						subItem = recFunc(newItem, item, s, skipFuncs, noOverwrite, noRecurse, defprop, usingAltKeys, keepArrays);
						cprop(r, p, subItem, TRUE, TRUE, TRUE);
					} else {
						r[p] = recFunc(newItem, item, s, skipFuncs, noOverwrite, noRecurse, defprop, usingAltKeys, keepArrays);
					}
				} else {
					if (defprop) {
						cprop(r, p, item, TRUE, TRUE, TRUE);
					} else {
						r[p] = item;
					}
				}
			} else {
				if (defprop) {
					cprop(r, p, item, TRUE, TRUE, TRUE);
				} else {
					r[p] = item;
				}
			}
		}
	}

	/*
    * inner functions, that are called soley as the result of some outer function
    * (regardless of them being defined inside said outer function, or outside),
    * should be named using the initial outer function name as a prefix, followed by '_'
    * and then the function name for that given function.
    *
    * So for example, the fitt.mix function is actually function mix
    *
    * mix has 3 helper functions, 2 of which do iteration in 2 different ways
    * depending on the input arguments, and 1 of which is logical operation for
    * each iteration run.
    *
    * So we name each of the helper functions with mix_doSomething, to help identify
    * the code flow / ownership
   */

	/**
       * A helper function for iterating over a given object.  In this case {@link fitt.mix} has been
       * called where the caller wants to only copy 'owned' properties, and so this function optimizes
       * how the loop is done to improve performance.
       *
       * Completely private, called when {@link fitt.mix} is called with a owned parameter of true.
       *
       * @name fitt-mix_iterateOwned
       * @function
       * @private
       * @param {Object} r The object to mix properties into (receiver object).
       * @param {Object} s The object which supplies the values (and property names) for the r parameter.
       * @param {Object} u Alternate filter object, which if specified is used to determine the property names that will be added to the r parameter.
       *					 Not used directly in this function, but passed back to the iteration function
       * @param {Boolean} [wantsMerge=false] If the receiver object already has a property of the given name and it's an object, do not overwrite the object
       *									   value said receiver object, but instead, copy/mixin properties into that object.  Requires recursion be on as well
       *									   (noRecurse=false which is the default).
       * @param {Boolean} [skipFuncs=false] Do not add properties to the object which are functions
       * @param {Boolean|Number} [noOverwrite=false] If true, and if the receiver already has a property of the given name, do not set it's value to that of what's in the supplier.
       * 											   If set to 2, then same logic applies but if the given property in the receiver is an object, allow recursive mixin from the supplier
       *											   to occur (in other words allows further annotation of an exising object).
       * @param {Boolean} [noRecurse=false] If true, do not recurse down into objects, simply treat them as primitive values.
       * @param {Boolean} [useDefProp=false] If true, add the property to the receiver object using Object.defineProperty rather than just doing an implicit define of the property via
       *                                  a set.  This will be slightly slower, but will allow you to add own properties to objects that have a frozen proto object.
       * @return {Object} The r parameter is returned after mix completion.
       *
      */

	function mix_iterateOwned(r, s, u, skipFuncs, noOverwrite, noRecurse, useDefProp, usingAltKeys, keepArrays)
	{
		"use strict";
		var wantsMerge = noOverwrite === 2 && !noRecurse,
		idx = 0,
		ps = usingAltKeys ? keys(u) : keys(s),
		keyCnt = ps && ps.length || 0,
		p;

		/* you could in theory have a empty string as a key
      * or some other falsy value so don't use a while + assignment construct
     */
		for (; idx < keyCnt; idx++) {
			p = ps[idx];
			mix_loopLogic(r, s, u, p, wantsMerge, skipFuncs, noOverwrite, noRecurse, mix_iterateOwned, useDefProp, usingAltKeys, keepArrays);
		}

		return r;
	}

	/**
    * A helper function for iterating over a given object.  In this case {@link fitt.mix} has been
    * called where the caller wants both 'owned' and 'non-owned' (as in those inherited from the prototype chain).
    * properties, and so this function optimizes how the loop is done to improve performance.
    *
    * Completely private, called when {@link fitt.mix} is called with a owned parameter of false.
    *
    * @name fitt-mix_iterateNonOwned
    * @function
    * @private
    * @inner
    * @param {Object} r The object to mix properties into (receiver object).
    * @param {Object} s The object which supplies the values (and property names) for the r parameter.
    * @param {Object} u Alternate filter object, which if specified is used to determine the property names that will be added to the r parameter.
    *					 Not used directly in this function, but passed back to the iteration function
    * @param {Boolean} [wantsMerge=false] If the receiver object already has a property of the given name and it's an object, do not overwrite the object
    *									   value said receiver object, but instead, copy/mixin properties into that object.  Requires recursion be on as well
    *									   (noRecurse=false which is the default).
    * @param {Boolean} [skipFuncs=false] Do not add properties to the object which are functions
    * @param {Boolean|Number} [noOverwrite=false] If true, and if the receiver already has a property of the given name, do not set it's value to that of what's in the supplier.
    * 											   If set to 2, then same logic applies but if the given property in the receiver is an object, allow recursive mixin from the supplier
    *											   to occur (in other words allows further annotation of an exising object).
    * @param {Boolean} [noRecurse=false] If true, do not recurse down into objects, simply treat them as primitive values.
    * @param {Boolean} [useDefProp=false] If true, add the property to the receiver object using Object.defineProperty rather than just doing an implicit define of the property via
    *                                  a set.  This will be slightly slower, but will allow you to add own properties to objects that have a frozen proto object.
    * @return {Object} The r parameter is returned after mix completion.
    *
   */

	function mix_iterateNonOwned(r, s, u, skipFuncs, noOverwrite, noRecurse, useDefProp, usingAltKeys, keepArrays)
	{
		"use strict";
		var wantsMerge = noOverwrite === 2 && !noRecurse,
		p;

		u = usingAltKeys ? u : s;

		/*
                             * Loop optimization, yes we can safely not call hasOwnProperty
                             * (which some jslint/hint engines argue should be required when that's
                             * not really valid/true in many cases).
                            */

		/*jsl:ignore*/
		for (p in u)
		/*jsl:end*/
		{
			mix_loopLogic(r, s, u, p, wantsMerge, skipFuncs, noOverwrite, noRecurse, mix_iterateNonOwned, useDefProp, usingAltKeys, keepArrays);
		}

		return r;
	}

	/**
    * A helper function for mix when dealing with an array of multiple sources rather than a single source
    *
    * @param {Object} r The object to mix properties into (receiver object).
    * @param {Object} s The object which supplies the values (and property names) for the r parameter.
    * @param {Object} u Alternate filter object, which if specified is used to determine the property names that will be added to the r parameter.
    *					 Not used directly in this function, but passed back to the iteration function
    * @param {Boolean} [owned=false] If is a boolean, force only copying 'owned' properties from the given supplier.
    * @param {Boolean} [skipFuncs=false] Do not add properties to the object which are functions
    * @param {Boolean|Number} [noOverwrite=false] If true, and if the receiver already has a property of the given name, do not set it's value to that of what's in the supplier.
    * 											   If set to 2, then same logic applies but if the given property in the receiver is an object, allow recursive mixin from the supplier
    *											   to occur (in other words allows further annotation of an exising object).
    * @param {Boolean} [noRecurse=false] If true, do not recurse down into objects, simply treat them as primitive values.
    * @param {Boolean} [useDefProp=false] If true, add the property to the receiver object using Object.defineProperty rather than just doing an implicit define of the property via
    *                                  a set.  This will be slightly slower, but will allow you to add own properties to objects that have a frozen proto object.
    * @return {Object} The r parameter is returned after mix completion.
   */

	function mix_iterateSourceArray(r, s, u, owned, skipFuncs, noOverwrite, noRecurse, useDefProp, usingAltKeys, keepArrays)
	{
		var idx = 0,
		aryCnt = s.length,
		funcToCall = owned ? mix_iterateOwned : mix_iterateNonOwned,
		sitem;

		for (; idx < aryCnt; idx++)
		{
			sitem = s[idx];
			funcToCall(r, sitem, usingAltKeys ? u : sitem, skipFuncs, noOverwrite, noRecurse, useDefProp, usingAltKeys, keepArrays);
		}
		return r;
	}

	/**
    * A cloning function. . . set properties in a given object according to their values in another object. Similar to Object.assign,
    * or JSON.parse(JSON.stringify([object])), except that you pass in custom options for how the mixin occurs.
    * By default if no r parameter is passed, a generic base object is created automatically.
    *
    * Note that if you pass in an EMPTY object, with the right arguments, you must accept the return value as the result
    * and the r parameter is basically ignored, it's always a good idea just to accept the return result anyway, if
    * the JSON optimization is not used the behavior is still the same
    *
    * Note that this function DOES NOT create properties with the same property descriptor as the source, but rather
    * creates simple data properties.
    *
    * Also note that this function DOES NOT protect against circular references in most cases.  The only exception
    * to this is if you are copying only owned properties and do not want functions, in which case JSON is used
    * as an optimization, and most native JSON implementations will throw an error when circular references are detected.
    *
    * the various flags/options you can pass in will greatly determine speed.  for example if you are recursing through
    * an object (on by default), and know you don't care about arrays staying as arrays, don't have/want functions, and
    * don't care if properties are owned you can speed things up. . .
    *
    * Note also that some advanced options can only be set if you use the descriptor format for the 3rd argument,
    * rather than passing in multiple arguments.
    *
    * If you want to pass in multiple sources to be mixed/merged into a given target, simply pass the source/supplier argument
    * an array of things to be mixed. This is the default behvaior.
    * @example
   <pre>
      var foo = [{x:1,y:2}, {z:3} ],
          bar = {};
       bar = fitt.mix(bar, foo); //result is {x:1,y:1,z:3}
   </pre>
        * But you can also have the array itself treated as a single source if need be. .
       *@example
   <pre>
      var var foo = [10, 20, 30],
          bar = {};
       bar = fitt.mix(bar, foo, {snglSrc:true,skipFuncs:true}); //result is {'0':10,'1':20,'2':30,'length':3}
   </pre>
    *
    * @name fitt.mix
    * @function
    * @public
    * @param {Object} [r=new Object] The object to receive properties and values from another object (receiver object)
    * @param {Object|Function|Array} s The object from which (supplier/source object) to copy values (and by default the properties).
    * 							        Note that pasing a function is allowed but it is just treated as if it
    *							        were an normal object.  If an Array is passed, by default is is assumed that you want each item
    *                                  in the array to be a source item, mixing all of those items into a single object.  To treat the array
    *                                  as a single source, see {@link fitt.MixOptions}, and use a descriptor object for options.
    *
    * @param {Boolean|Object} [ownedOrOpts=false] If is a boolean, force only copying 'owned' properties from the given supplier. Otherwise you can pass in an
    *                                             object to define further parameters / options for this function.  See {@link fitt.MixOptions}. Note that
    *                                             passing an object will ignore further parameters defined below.
    *
    *
    * @param {Boolean} [ownedOrOpts.skipFuncs=false] Same as 4th argument skipFuncs parameter (see below)
    * @param {Boolean} [ownedOrOpts.owned=false] Use only owned properties, same as pasing 3rd parameter as a boolean true
    * @param {Boolean|Number} [ownedOrOpts.noOvr=false] When false allow properties to be overwritten, when true (truthy, 1 also accepted), do not allow properties to be overwritten.
    *                                                   If set to 2, then same logic applies but if the given property in the receiver is an object, allow recursive mixin from the supplier
    *											         to occur (in other words allows further annotation of an exising object).
    * @param {Object} [ownedOrOpts.recKeys=null] Only copy these properties from a source into the receiver, see 7th argument below (keysFromReceiver)
    * @param {Boolean} [ownedOrOpts.defProp=false] Use Object.defineProperty to set properties on the receiver rather than a simple dot / bracket set notation. Useful for some cases where
    *                                              an object is a proxy or has a getter/setter defined
    * @param {Boolean} [ownedOrOpts.snglSrc=false] The 2nd argument MUST be an instance of Array, and instead of using it has multiple source objects to be merged, when true, treats
    *                                              the array as a single source (meaning if your array has 3 items, your receiver object will get properties "0", "1", and "2").
    * @param {Boolean} [ownedOrOpts.keepArrays=true] Set to false to boost performance, but with the caveat of array-like objects being converted into normal objects as opposed to staying arrays.
    * @param {Boolean} [skipFuncs=false] Do not add properties to the object which are functions
    * @param {Boolean|Number} [noOverwrite=false] If true, and if the receiver already has a property of the given name, do not set it's value to that of what's in the supplier.
    * 											   If set to 2, then same logic applies but if the given property in the receiver is an object, allow recursive mixin from the supplier
    *											   to occur (in other words allows further annotation of an exising object).
    * @param {Boolean} [noRecurse=false] If true, do not recurse down into objects, simply treat them as primitive values.
    * @param {Object|Boolean} [keysFromReceiver=null]  If argument is true, then we will iterate over the properties in the receiver object, and copy values from the source object.
    *												    If argument is an object, then only properties from this object will be used it copy values (think of it like a filter object).
    *													In either case, if there is recursion (which is the default), the same list of properties are copied throughout each level of recursion
    * @param {Boolean} [useDefProp=false] If true, add the property to the receiver object using Object.defineProperty rather than just doing an implicit define of the property via
    *                                  a set.  This will be slightly slower, but will allow you to add own properties to objects that have a frozen proto object.
    * @return {Object} The receiver object.
   */




	function mix(r, s, ownedOrOpts, skipFuncs, noOverwrite, noRecurse, keysFromReceiver, useDefProp)
	{
		var args = arguments,
		argCnt = args.length,
		emptyR = FALSE,
		srcIsAry = FALSE,
		haveOptsObj = FALSE,
		singleSourceAry = FALSE,
		useOwnedProps = FALSE,
		usingAltKeys = FALSE,
		keepArrays = TRUE,
		utyp = "",
		useKeysObj = NULL,
		strJSON = "";

		if (!isObjLike(r)) {
			emptyR = TRUE;
			r = {};
		}

		if (!isObjLike(s)) return r;

		srcIsAry = isAryLike(s, TRUE);
		srcIsAry = srcIsAry === 1;

		if (argCnt <= 3) haveOptsObj = isObjLike(ownedOrOpts);

		if (!haveOptsObj) {
			useOwnedProps = !!ownedOrOpts;

			/*
                                   * if the receiver was not an object (above) then we already know
                                   * it's empty and so we control what needs to be returned and therefore
                                   * can pick JSON optimization for example.
                                   *
                                   * if the receiver was a valid object, then we don't yet really
                                   * know if the object is empty so we do that here. . .we have
                                   * to wait to do it here since we just now computed whether
                                   * the user/caller wanted us to only deal with owned props or not.
                                  */

			if (!emptyR) {
				emptyR = empty(r, useOwnedProps ? 1 : 0, TRUE);
			}
		} else {
			useOwnedProps = !!ownedOrOpts.owned;

			if (!emptyR) {
				if (!("empty" in ownedOrOpts)) {
					emptyR = empty(r, useOwnedProps ? 1 : 0, TRUE);
				}
			}

			singleSourceAry = !!(srcIsAry && ownedOrOpts.snglSrc);
			keysFromReceiver = !!ownedOrOpts.recKeys;
			noRecurse = !!ownedOrOpts.noRecurse;
			useDefProp = !!ownedOrOpts.defProp;
			skipFuncs = !!ownedOrOpts.skipFuncs;
			keepArrays = "keepArrays" in ownedOrOpts ? !!ownedOrOpts.keepArrays : keepArrays;
			noOverwrite = ownedOrOpts.noOvr;

		}

		if (keysFromReceiver) {
			utyp = typeof keysFromReceiver;
			if (utyp == TYPE_OBJ || utyp == TYPE_FUNC) {
				useKeysObj = keysFromReceiver;
				usingAltKeys = TRUE;
			} else {
				useKeysObj = r;
				usingAltKeys = TRUE;
			}
		} else {
			useKeysObj = s;
		}

		/*
     * Optimization logic:
     *
     * Our mix has a lot of different varied options, and various combinations allow
     * us to skip doing our own iteration over an object in favor of the JS engine doing something
     *
     * these boil down into 2 main categories
     *
     * 1.) JSON mode -- you passed in an empty object to mix into (no override is false / implied b/c the tgt is empty),
     *                  don't want functions, only want owned props, do want recursion, no filtered keys, and you are
     *                  not passing in multiple sources.
     *
     * 2.) Native Object.assign -- no filter keys, only owned props, and NO recursion, and allow receiver props to be overriden by
     *                             props in source(s)
     *
    */
		if (useOwnedProps && keepArrays && !keysFromReceiver && emptyR && (!srcIsAry || srcIsAry && !singleSourceAry) && skipFuncs && !noRecurse) {
			strJSON = jsnStringify(s);
			r = jsnParse(strJSON);
		} else if (useOwnedProps && !keysFromReceiver && noRecurse && !noOverwrite && obj_assign) {
			if (srcIsAry && !singleSourceAry) {
				r = obj_assign.apply(NULL, [r].concat(s));
			} else {
				r = obj_assign(r, s);
			}
		} else {
			if (srcIsAry && !singleSourceAry) {
				r = mix_iterateSourceArray(r, s, useKeysObj, useOwnedProps, skipFuncs, noOverwrite, noRecurse, useDefProp, usingAltKeys, keepArrays);
			} else {
				if (useOwnedProps) {
					r = mix_iterateOwned(r, s, useKeysObj, skipFuncs, noOverwrite, noRecurse, useDefProp, usingAltKeys, keepArrays);
				} else {
					r = mix_iterateNonOwned(r, s, useKeysObj, skipFuncs, noOverwrite, noRecurse, useDefProp, usingAltKeys, keepArrays);
				}
			}
		}

		return r;
	}

	/**
    * Create a namespace or check for the existence of a namespace like string
    * within an object.  Uses global by default in browsers only, otherwise when
    * run server-side will use the "fitt" object exported by this module as the root
    * unless the forceServerSideGlobal argument is true. This is done to avoid cyclical reference / closure
    * memory leak issues with JavaScript modules particularly in NodeJS.
    *
    * @name fitt.ns
    * @function
    * @public
    * @param {String} strNS A string representing a namespace within an object (defaulting to global).  Format of string MUST use dot notation (e.g. "name.foo.bar").
    *
    * @param {Object} [aug=null] A descriptor object with each key being the name of a property on the end of the namespace to be added or changed, with whatever given value desired.
    *							  If not specified a default object is used to create the namespace end point.
    *
    * @param {Object|Function} [root=null] Create / find the namespace using this given argument as the root. Default is to use the global namespace
    *
    * @param {Boolean} [ovr=false] Forcibly overwrite an existing namespace object.
    *
    * @param {Boolean} [forceServerSideGlobal=false] Attach to or check the namespace string against the global object when running server-side
    *
    * @return {Object|Function|Boolean} depending on mode
    *
   */

	function ns(strNS, aug, root, ovr, forceServerSideGlobal) {
		"use strict";

		var obj = isObjLike(root) ? root : isBrowser() || forceServerSideGlobal ? getGlobal() : {},
		idx = 0,
		per = ".",
		ret = NULL,
		noOvr = !ovr,
		ar,item,objVal,dontSet,canMix;

		if (strNS) {
			strNS = cstr(strNS);
			aug = isObjLike(aug) ? aug : NULL;
			if (idxOf(strNS, per) !== NEG_ONE) {
				ar = strNS.split(per);
				/*jsl:ignore*/
				while (item = ar[idx++])
				/*jsl:end*/
				{
					item = trim(item, TRUE);
					objVal = obj[item];
					canMix = isObjLike(objVal);
					dontSet = !!(noOvr && canMix);

					if (idx == ar.length) {
						if (canMix && aug) {
							ret = obj[item] = mix(objVal, aug, FALSE, FALSE, 2);
						} else {
							if (dontSet) {
								ret = objVal;
							} else {
								ret = obj[item] = objVal || aug || {};
							}
						}
					} else {
						if (dontSet) {
							ret = objVal;
						} else {
							ret = obj[item] = objVal || {};
						}
					}
					obj = ret;
				}
			} else {
				objVal = obj[strNS];
				canMix = isObjLike(objVal);

				if (canMix && aug) {
					ret = obj[strNS] = mix(objVal, aug, FALSE, FALSE, 2);
				} else {
					if (!objVal && !aug) {
						ret = obj[strNS] = {};
					} else if (!aug) {
						ret = objVal;
					} else {
						ret = aug;
					}
				}
			}
		}
		return ret;
	}

	/**
    * Check to see if a given object/function has an "own" property
    *
    * @name fitt.owns
    * @function
    * @public
    * @param {Object|Function} o The object to inspect
    * @param {String} p The name of the property
    * @param {Boolean} [ots=false] Passing true skips validating that the input object is truly an object or function (small performance gain).
    * @param {Boolean} [pts=false] Passing true skips forcing the conversion of a property name into a string (small performance gain).
    * @return {Boolean}
   */

	function owns(o, p, ots, pts)
	{
		p = pts ? p : cstr(p);
		o = ots || isObjLike(o) ? o : FALSE;

		return p && o && $obj_owns.call(o, p);
	}

	/**
    * Check to see if a object is an instance of the given prototype. For example fitt.kindOf({}, Object.prototype).  Wrapper for Object.prototype.isPrototypeOf
    *
    * @name fitt.kindOf
    * @function
    * @public
    * @param {Object|Function} o The object instance to inspect
    * @param {Object} The prototype object instance to check
    * @param {Boolean} [ots=false] Passing true skips validating that the 1st argument is a true object / function (small perfomance gain).
    * @param {Boolean} [pts=false] Passing true skips validating that the 2nd argument is a true object / function (small peformance gain).
    * @return {Boolean}
   */

	function kindOf(o, p, ots, pts)
	{
		return (ots || isObjLike(o)) && (pts || isObjLike(p)) && $obj_kindOf.call(p, o);
	}

	/**
    * Wrapper around JavaScript ASCII [en/de]codeURI/[en/de]codeURIComponent/[es|unes]cape global functions,
    * ensures conversion into a string and allows you to wrap (or not) the call in a try/catch block if you are unsure of
    * the incoming type (as in it's not a true javascript object that can safely convert to
    * a string).
    *
    * @name fitt.encdec
    * @function
    * @public
    * @param {*} str The string to ASCII encode/decode.
    * @param {Object} [options=null] A descriptor object to pass various optional arguments for varied features
    * @param {String} [options.method='comp'] Which encode function to use. Valid values are:
    * <dl>
    *  <dt>'comp' (Default)</dt>
    *  <dd>Use the 'encodeURIComponent/decodeURIComponent' global function</dd>
    *  <dt>'uri'</dt>
    *  <dd>Use the 'encodeURI/decodeURI' global function</dd>
    *  <dt>'esc'</dt>
    *  <dd>Use the 'escape/unescape' global function</dd>
    *</dl>
    * @param {Boolean} [options.safe=true] Whether the call to the underlying encode function is wrapped in a try /catch. If wrapped and an error occurs an empty string is retuned
    * @param {Boolean} [options.cstr=true] Whether the argument passed is forcibly converted to a string first using {@link fitt.cstr}
    * @param {Boolean} [options.enc=true] Whether to encode or decode the string (encode is the default)
    * @return {String}
    */

	function encodeDecode(str, options)
	{
		var ret = '',
		hasOptsObj = isObj(options),
		whichFunc = cstr(hasOptsObj && options.method),
		doEncoding = TRUE,
		useCstr = TRUE,
		useTry = TRUE,
		func,strVal;

		if (hasOptsObj) {
			useCstr = 'cstr' in options ? !!options.cstr : TRUE;
			useTry = 'safe' in options ? !!options.safe : TRUE;
			doEncoding = 'enc' in options ? !!options.enc : TRUE;
		}

		try {
			switch (whichFunc) {
				case 'uri':
					if (doEncoding) {
						func = encodeURI;
					} else {
						func = decodeURI;
					}
					break;
				case 'esc':
					if (doEncoding) {
						func = escape;
					} else {
						func = unescape;
					}
					break;
				default:
					if (doEncoding) {
						func = encodeURIComponent;
					} else {
						func = decodeURIComponent;
					}
					break;}

		} catch (e) {}

		if (func) {
			if (useCstr) {
				strVal = cstr(str);
			} else {
				strVal = str;
			}
			if (strVal) {
				if (useTry) {
					try {
						ret = func(strVal);
					} catch (e) {
						ret = '';
					}
				} else {
					ret = func(strVal);
				}
			}
		}

		return ret;
	}

	/**
    * Wrapper around JavaScript escape global function, ensures conversion into a string
    * and allows you to wrap (or not) the call in a try/catch block if you are unsure of
    * the incoming type (as in it's not a true javascript object that can safely convert to
    * a string).
    *
    * @name fitt.es
    * @function
    * @public
    * @param {*} str The string to ASCII escape.  Note that this PURPOSEFULLY uses the escape function rather than encodeURI or encodeURIComponent
    *                 because it's faster and also encodes some characters that are not always encoded (but may need to be).
    * @return {String}
    */

	function es(str) {
		return encodeDecode(str, { method: 'esc' });
	}

	/**
    * Opposite of {@link fit.es}.  Decodes an ASCII encoded string using the global unescape function.
    *
    * @name fitt.ues
       * @function
       * @public
       * @param {*} str The string to ASCII unescape.  Note that this PURPOSEFULLY uses the unescape function rather than decodeeURI or decodeURIComponent
       *                 because it's faster.
       * @return {String}
      */

	function ues(str) {
		return encodeDecode(str, { method: 'esc', enc: false });
	}

	/**
    * Wrapper around encodeURIComponent for saftey, shorthand for <code>fitt.encdec(str);</code>
    *
    * @name fitt.encURIComp
    * @function
    * @public
    * @param {*} str
    * @return {String}
   */

	function encURIComp(str) {
		return encodeDecode(str);
	}

	/**
    * Wrapper around decodeURIComponent for saftey, shorthand for <code>fitt.encdec(str,{enc:false})</code>
    *
       * @name fitt.decURIComp
       * @function
       * @public
       * @param {*} str
       * @return {String}
      */

	function decURIComp(str) {
		return encodeDecode(str, { enc: false });
	}

	/**
    * Wrapper around encodeURI for saftey, shorthand for <code>fitt.encdec(str,{method:'uri'})</code>
    *
       * @name fitt.encURI
       * @function
       * @public
       * @param {*} str
       * @return {String}
      */

	function encURI(str) {
		return encodeDecode(str, { method: 'uri' });
	}

	/**
   * Wrapper around decodeURI for saftey, shorthand for <code>fitt.encdec(str,{method:'uri',enc:false})</code>
   *
    * @name fitt.decURI
    * @function
    * @public
    * @param {*} str
    * @return {String}
   */

	function decURI(str) {
		return encodeDecode(str, { method: 'uri', enc: false });
	}

	/**
    * Static wrapper around common String / Array prototype methods indexOf and lastIndexOf
    * Function will automatically convert the given 1st argument into a string unless
    * that object has a property / method "indexOf" or "lastIndexOf" (like arrays in modern
    * JS do).
    *
    * @name fitt.idxOf
    * @function
    * @public
    * @param {String|Array} haystack The string or array to search through.  If an object is passed in which does not have an indexOf or lastIndexOf method, it
    *                                will first be converted into a string.
    * @param {String} needle The substring to search for
    * @param {Boolean} [useLast=false] Search from the begining or ending of the string (defaults to begining)
    * @param {Number} [fromIndex=0|haystack.length] The starting index in the string or array to search through, defaults to 0 if searching from the start of the string / array
    *                                               or the length of the string / array if searching from the back.
    * @return {Number} returns -1 if item not found.
    *
   */

	function idxOf(haystack, needle, useLast, fromIndex)
	{
		var meth = useLast ? "lastIndexOf" : "indexOf",
		hasFromIndex = arguments.length > 3,
		ret = NEG_ONE,
		hayType = typeof haystack;

		if (useLast) {
			if (!hasFromIndex) {
				fromIndex = haystack.length || 0;
			}
		} else {
			if (!hasFromIndex) {
				fromIndex = 0;
			}
		}

		switch (hayType) {

			case TYPE_UNDEF:return ret;
			case TYPE_FUNC:
			case TYPE_NUM:
			case TYPE_BOOL:
				return str(haystack)[meth](needle, fromIndex);
			case TYPE_STR:
				return !haystack ? ret : haystack[meth](needle, fromIndex);
			case TYPE_OBJ:
				if (!haystack) return ret;

				if (meth in haystack) return haystack[meth](needle, fromIndex);

				return str(haystack)[meth](needle, fromIndex);}


		return ret;
	}

	/**
    * Static wrapper around String.prototype.substring
    *
    * @name fitt.subStr
    * @function
    * @public
    * @param {String} haystack Base string to use for extracting. If haystack param is null or undefined an empty string is returned.
    *                          If argument is not a string it will be converted into a string.
    * @param {Number} start
    * @param {Number} end
    * @return {String}
   */

	function subStr(haystack, start, end)
	{
		var haytyp = typeof haystack,
		hasEndArg = arguments.length > 2,
		SUBSTR = "substring";

		if (haystack == NULL) return '';
		if (haytyp !== TYPE_STR) {
			haystack = str(haystack);
		}

		if (!haystack) return '';

		return hasEndArg ? haystack[SUBSTR](start, end) : haystack[SUBSTR](start);
	}

	/**
    * Static wrapper around String.prototype.charAt, which will also use newer functionality
    * where string parts can be accessed via [] (slight performance improvement), if the environment
    * supports it.
    *
    * @name fitt.charAt
    * @function
    * @public
    * @param {String} str The given string
    * @param {Number} idx The index in the string to look
    * @return {String} representing a single character in the string void/undefined if the index is out of bounds
    *
   */

	function charAt(str, idx) {};

	charAt = function () {

		var str = "hello",
		fsrc;

		try {
			strArrayAccess = str[1] === 'e' && str[2] === 'l';
		} catch (e) {
			strArrayAccess = FALSE;
		}

		if (strArrayAccess) {
			fsrc = function charAt(str, idx) {return str[idx];};
		} else {
			fsrc = function charAt(str, idx) {return str.charAt(idx);};
		}

		return fsrc;
	}();


	/**
       * Polyfill support for Object.keys in cases of no ECMAScript 5 support,
       * otherwise simply a pointer to the default Object.keys native function
       *
       * @name fitt.keys
       * @function
       * @public
       * @param {Object|Function} o The object instance to inspect
       * @return {String[]} An array of property names (strings), that are owned and enumerable.
       *
      */

	function keys(o) {}

	keys = function () {
		var f, fc, fsrc;

		if (obj_keys) return obj_keys;
		fsrc =
		[
		"return (function(o) {\n",
		"\n",
		"   var a = [], n;\n",
		"   if (isObjLike(o)) {\n",
		"       for (n in o)\n",
		"       {\n",
		"           if (owns(o, n, TRUE, TRUE)) {\n",
		"               a.push(n);\n",
		"           }\n",
		"       }\n",
		"   }\n",
		"   return a;\n",
		"});\n"];

		fsrc = cstr(fsrc);
		fc = func("owns", "isObjLike", "TRUE", fsrc);
		f = fc(owns, isObjLike, TRUE);
		return f;
	}();

	/**
       * Check to see if a given reference is empty.  Passing a primitive value that evaluate to false, will
       * cause this function to return true (they are considered empty). The default is tObjects / functions are considered
       * empty if they have no enumerable properties (INCLUDING ANYTHING INHERITED FROM THE PROTOTYPE CHAIN). You
       * can require that properties also be be owned and enumerable, or simply owned properties (both enumerable and non-enumerable)
       * by switching modes (note that this feature only works with full ECMAScript 5 support environments).
       *
       * @name fitt.empty
       * @function
       * @public
       * @param {*} o  The thing to inspect
       * @param {Number} [mode=0] What types properties on the given object / function (assuming the 1st argument is indeed an object/ function),
       * 							should be considered.
       *							<dl>
       *								<dt>0 (default)</dt>
       *								<dd>Consider any enumerable properties, whether they are owned properties or inherited via the prototoype chain,
       *									as making the object non-empty.</dd>
       *								<dt>1</dt>
       *								<dd>Require all properties be owned and enumerable.  An object with no owned and enumerable properties is considered empty.</dd>
       *								<dt>2</dt>
       *								<dd>Require all properties be owned, but allow both enumerable and non-enumerable properties to be considered.</dd>
       *							</dl>
       * @return {Boolean}
       *
      */

	/*
          * we define the function up front here empty since we're
          * going to do a generated implementation below.  This way
          * most IDE's still pick it up in their tools, and we don't
          * have to define a variable for it.
         */

	/** @ignore */
	function empty() {}

	/*
                      * Since there is a possibility (very low) of not having ECMAScript 5
                      * support, we build this (and a few other) functions dynamically,
                      * rather than always checking for those features each run.
                      * As a general rule, we return a closure function from our function
                      * constructor b/c functions created purely with strings via a function
                      * constructor have their body/source re-evaluated each time they run
                      * and thereby drag down performance.
                     */

	/** @ignore */
	empty = function () {

		var f, fc, fsrc;

		if (typeof obj_keys == TYPE_FUNC && typeof obj_props == TYPE_FUNC) {
			/*
                                                                       * to save space with compression, we create a named "empty"
                                                                       * function inside an IIEF, which also prevents the named
                                                                       * function from being a variable in our outer scope,
                                                                       * and then we convert that to a string and use a function
                                                                       * constructor to redefine the source, so that said function
                                                                       * only holds references to the dependancies that it needs
                                                                      */

			fsrc =
			[
			"return (function(o,m,ots) {\n",
			"   var emp = TRUE, p;\n",
			"   if (!o) return TRUE;\n",
			"   if (!ots && !isObjLike(o)) return FALSE;\n",
			"   if (m === 1) return !(obj_keys(o).length);\n",
			"   if (m === 2) return !(obj_props(o).length);\n",
			"   for (p in o) {\n",
			"       emp = FALSE;\n",
			"       break;\n",
			"   }\n",
			"   return emp;\n",
			"});\n"];

			fsrc = cstr(fsrc);
			fc = func("obj_keys", "obj_props", "isObjLike", "TRUE", "FALSE", fsrc);
			f = fc(obj_keys, obj_props, isObjLike, TRUE, FALSE);
		} else {
			fsrc =
			[
			"return (function(o,m,ots) {\n",
			"   var emp = TRUE, p;\n",
			"   if (!o) return FALSE;\n",
			"   if (!ots && !isObjLike(o)) return FALSE;\n",
			"   if (m === 2) throw new Error('call to fitt.empty with mode 2 failed, environment does not support ECMAScript5');\n",
			"   for (p in o) {\n",
			"   if (m === 1 && !owns(o,p)) continue;\n",
			"       emp = FALSE;\n",
			"       break;\n",
			"   }\n",
			"   return emp;\n",
			"});\n"];

			fsrc = cstr(fsrc);
			fc = func("owns", "isObjLike", "TRUE", "FALSE", fsrc);
			f = fc(owns, isObjLike, TRUE, FALSE);
		}

		return f;
	}();


	/** @ignore */
	function trim() {}

	/**
                     * Shorthand / wrapper for String.prototype.trim which is only available in ECMAScript 6.
                     *
                     * @name fitt.trim
                     * @public
                     * @function
                     * @param {String|*} s A string to trim the whitespace from the left and right sides. You may also pass in an object or non-string type, and it will be converted.
                     * @param {Boolean} [its=false] Pass true to dictate that the 1st argument is indeed a string (small performance gain).
                     * @return {String}
                    */

	/** @ignore */
	trim = function () {

		var f, fc;

		if (typeof $str_trim == TYPE_FUNC) {
			fc = func("$str_trim", "cstr",
			cstr([
			TYPE_FUNC, " trim(s,its) { ",
			"	s = (its) ? s : cstr(s); ",
			"	", RETURN, " $str_trim.call(s); ",
			"}; ",
			RETURN, " trim;"]));


			f = fc($str_trim, cstr);
		} else {
			fc = func("cstr",
			cstr([
			TYPE_FUNC, " trim(s,its) { ",
			"	s = (its) ? s : cstr(s); ",
			"	", RETURN, " s.replace(/^\s\s*/, '').replace(/\s\s*$/, ''); ",
			"}; ",
			RETURN, " trim;"]));


			f = fc(cstr);
		}

		return f;
	}();

	/** @ignore */
	function now() {};

	/**
                     *  Shorthand / wrapper around getting the currently known time (client-side), which either calls
                     *  (new Date()).getTime(), or Date.now() (in modern browsers which is also faster).
                     *
                     * @name fitt.now
                     * @function
                     * @return {Number} The current time in milliseconds from the epoch (Jan 1, 1970).
                    */

	now = function () {

		var hasErr = FALSE,val,dteNow,ret,fc;

		try {
			dteNow = dte.now;
			val = dteNow();
			if (!isNum(val)) {
				hasErr = TRUE;
			}
		} catch (e) {
			hasErr = TRUE;
		}

		if (!hasErr) {
			ret = dteNow;
		} else {
			fc = func("d", cstr([RETURN, " (", TYPE_FUNC, "() { ", RETURN, " (new d()).getTime(); });"]));
			ret = fc(dte);
		}

		return ret;
	}();

	/** @ignore */
	function getGlobal() {}

	/**
                          * Get a reference to the top level / global object for the given realm / window,
                          * or a variable that's defined in global scope.
                          *
                          * Note that globally defined variables using "const" or "let" operators, do
                          * not actually attach themselves to the global object as opposed named function
                          * declarations and "var" statements.  So for example, in a script you have something
                          * globally defined via let / const (which really can only happen in a browser):<br />
                          <pre>
                             let foo = 100;
                         	    alert(window.foo); //undefined
                          </pre>
                          *<br />
                          *
                          * This function will allow you to still get at said global:<br />
                          <pre>
                             let foo = 100;
                         	    alert(fitt.getGlobal("foo")); //100
                          </pre>
                          *
                          *
                          * @name fitt.getGlobal
                          * @function
                          * @param {String} [varName=""]  If passed, will attempt to find the given variable name in the global object, otherwise this function just returns the global object.
                          * @param {*} [defaultValue=void|undefined] If specified, will be returned when the global object cannot be found (shoudl be never), or mainly used for trying to find
                          *                                          out if a global variable exists.
                          * @public
                          * @return {Object|*} if using a varName argument, returns the value of said argument (which could be any type), if indentifier does not exist, returns your default value
                          *                    specifed, or undefined (we allow you to pass your own default to let you be able to tell the difference between an identifier that does not exist, versus
                          *                    existing, but set as an undefined value.  If you pass no varName argument, simply returns a hook to the global object (window in browsers, global in NodeJS).
                         */



	/** @ignore */
	getGlobal = function () {

		var gg, fc; //stores the chosen function to get the global object
		/*
   * the 3rd case below should never really happen
   * we use a function constructor that returns its own
   * inline function so that it will still get optimized
   * by modern JS engines (rather than functions from constructors
   * which are re-parsed every time they run), and we use
   * the function constructor so that we don't have to hold
   * ref to the main window/global ourselves for ever
  */
		function ggv(nm, def)
		{
			var findFailed = FALSE,fc,gfv,ret;

			nm = cstr(nm);

			if (nm) {
				if (nm in globalVarNameCache) {
					gfv = globalVarNameCache[nm];
				} else {
					try {
						fc = func(cstr([RETURN, " (", TYPE_FUNC, "() { ", RETURN, " ", nm, "; });"]));
						gfv = fc();
					} catch (e) {
						gfv = NULL;
					}
				}
				if (gfv) {
					try {
						ret = gfv();
					} catch (e) {
						findFailed = TRUE;
					}
				} else {
					findFailed = TRUE;
				}

				return findFailed ? arguments.length > 1 ? def : UNDEF : ret;
			}
			return gg();
		}

		/*
     * dynamcically build a function via string that returns
     * another function to get the global object.
     * We return a function out of the constructed function
     * so that the string code doesn't get re-parsed every time it runs
     * (an optimization, b/c functions constructed via string always get their body re-parsed).
    */
		if (typeof window == TYPE_OBJ) {
			fc = func(cstr([RETURN, "(", TYPE_FUNC, "() { ", RETURN, " ", WIN, "; });"]));
		} else if (typeof global == TYPE_OBJ) {
			fc = func(cstr([RETURN, "(", TYPE_FUNC, "() { ", RETURN, " ", GLOBAL, "; });"]));
		} else {
			fc = func(cstr([RETURN, "(", TYPE_FUNC, "() { throw new TypeError('no ", GLOBAL, " hook found'); });"]));
		}
		gg = fc();

		return ggv;
	}();

	/**
       * A reliable way to detect that we are running in a browser. Currently
       * grabs onto the global object and attempts to create a temporary DOM element
       * and validate that HTML parsing works.  Since an environment would have to
       * fake the DOM and HTML parsing in order to trick the function it's a pretty
       * safe bet.
       *
       * @name fitt.isBrowser
       * @function
       * @return {Boolean}
      */

	function isBrowser() {}

	isBrowser = function () {

		var win = getGlobal(),
		ret = FALSE,
		doc,tempEl,firstChild;

		try {
			doc = win.document;
			tempEl = doc.createElement('div');
			tempEl.innerHTML = '<div id="browserCheck"></div>';
			firstChild = tempEl.firstChild;
			ret = !!(firstChild && firstChild.id === 'browserCheck');
		} catch (e) {
			ret = FALSE;
		}

		return ret ? rtrue : rfalse;

	}();


	/**
       * Shorthand constant for the string "prototype"
       *
       * @name fitt.PROTO
       * @constant
       * @public
       * @type {String}
      */

	exp.PROTO = PROTO;


	/**
                     * Shorthand constant for the string "__proto__"
                     *
                     * @name fitt.UPROTO
                     * @constant
                     * @public
                     * @type {String}
                     *
                    */

	exp.UPROTO = UPROTO;

	/**
                       * Shorthand constant for the string "constructor"
                       *
                       * @name fitt.CONSTRUCT
                       * @constant
                       * @public
                       * @type {String}
                      */

	exp.CONSTRUCT = CONSTRUCT;

	/**
                             * Shorthand constant for "toString"
                             *
                             * @name fitt.TO_STR
                             * @constant
                             * @public
                             * @type {String}
                            */

	exp.TO_STR = TO_STR;

	/**
                       * Shorthand constant for "value"
                       *
                       * @name fitt.VALUE
                       * @constant
                       * @public
                       * @type {String}
                      */

	exp.VALUE = VALUE;

	/**
                     * Shorthand constant for "valueOf"
                     *
                     * @name fitt.VALUE_OF
                     * @constant
                     * @public
                     * @type {String}
                    */

	exp.VALUE_OF = VALUE_OF;

	/**
                           * Shorthand constant for "string" (as in the result of typeof on a string value)
                           *
                           * @name fitt.TYPE_STR
                           * @constant
                           * @public
                           * @type {String}
                          */

	exp.TYPE_STR = TYPE_STR;

	/**
                           * Shorthand constant for "number" (as in the result of typeof on a number value)
                           *
                           * @name fitt.TYPE_NUM
                           * @constant
                           * @public
                           * @type {String}
                          */

	exp.TYPE_NUM = TYPE_NUM;

	/**
                           * Shorthand constant for "boolean" (as in the result of typeof on a boolean value)
                           *
                           * @name fitt.TYPE_BOOL
                           * @constant
                           * @public
                           * @type {String}
                          */

	exp.TYPE_BOOL = TYPE_BOOL;

	/**
                             * Shorthand constant for "function" (as in the result of a typeof on a function reference)
                             *
                             * @name fitt.TYPE_FUNC
                             * @constant
                             * @public
                             * @type {String}
                            */

	exp.TYPE_FUNC = TYPE_FUNC;

	/**
                             * Shorthand constant for "object" (as in the result of a typeof on an object (or null) reference)
                             *
                             * @name fitt.TYPE_OBJ
                             * @constant
                             * @public
                             * @type {String}
                            */

	exp.TYPE_OBJ = TYPE_OBJ;

	/**
                           * Shorthand constant for "symbol" (as in the result of a typeof on a symbol value)
                           *
                           * @name fitt.TYPE_SYM
                           * @constant
                           * @public
                           * @type {String}
                          */

	exp.TYPE_SYM = TYPE_SYM;

	/**
                           * Shorthand constant for "undefined"
                           *
                           * @name fitt.TYPE_UNDEF
                           * @constant
                           * @public
                           * @type {String}
                          */

	exp.TYPE_UNDEF = TYPE_UNDEF;

	/**
                               * Shorthand constant for "unknown"
                               * Note that the typeof operator in JavaScript on IE 9 browsers and below
                               * can return this value in cases where a reference is being deleted / removed
                               * from memory or if the reference in JavaScript points to some other native but not
                               * JavaScript based object (like VBScript).
                               *
                               * @name fitt.TYPE_UNKNOWN
                               * @constant
                               * @public
                               * @type {String}
                              */


	exp.TYPE_UNKNOWN = TYPE_UNKNOWN;

	/**
                                   * Shorthand constant for "configurable" (commonly used in property descriptors of objects)
                                   *
                                   * @name fitt.CAN_CONF
                                   * @constant
                                   * @public
                                   * @type {String}
                                  */

	exp.CAN_CONF = CAN_CONF;

	/**
                           * Shorthand constant for "writable" (commonly used in property descriptors of objects)
                           *
                           * @name fitt.CAN_WRITE
                           * @constant
                           * @public
                           * @type {String}
                          */

	exp.CAN_WRITE = CAN_WRITE;

	/**
                             * Shorthand constant for "enumerable"  (commonly used in property descriptors of objects)
                             *
                             * @name fitt.CAN_ENUM
                             * @constant
                             * @public
                             * @type {String}
                            */

	exp.CAN_ENUM = CAN_ENUM;

	/**
                           * Shorthand constant for "__defineGetter__" (legacy getter definition pre-ECMAScript 5 which
                           * is still used in some fallback cases).
                           *
                           * @name fitt.DEF_GET
                           * @constant
                           * @public
                           * @type {String}
                          */

	exp.DEF_GET = DEF_GET;

	/**
                         * Shorthand constant for "__defineSetter__" (legacy setter definition definition pre-ECMAScript 5 which
                         * is still used in some fallback cases).
                         *
                         * @name fitt.DEF_SET
                         * @constant
                         * @public
                         * @type {String}
                        */

	exp.DEF_SET = DEF_SET;

	/**
                         * Shorthand constant for null value
                         *
                         * @name fitt.NULL
                         * @constant
                         * @public
                         * @type {Null}
                        */

	exp.NULL = NULL;

	/**
                   * Shorthand constant for undefined (void 0) value
                   *
                   * @name fitt.UNDEF
                   * @constant
                   * @public
                   * @type {void}
                  */

	exp.UNDEF = UNDEF;

	/**
                     * Shorthand constant for true value (boolean)
                     *
                     * @name fitt.TRUE
                     * @constant
                     * @public
                     * @type {Boolean}
                    */

	exp.TRUE = TRUE;

	/**
                   * Shorthand constant for false value (boolean)
                   *
                   * @name fitt.FALSE
                   * @constant
                   * @public
                   * @type {Boolean}
                  */
	exp.FALSE = FALSE;

	/**
                     * Shorthand constant for -1 (number)
                     *
                     * @name fitt.NEG_ONE
                     * @constant
                     * @public
                     * @type {Number}
                    */

	exp.NEG_ONE = NEG_ONE;

	/**
                         * Shorthand for core JavaScript Object constructor
                         *
                         * @name fitt.obj
                         * @constant
                         * @public
                         * @type {Function}
                        */

	exp.obj = obj;

	/**
                 * Shorthand for core JavaScript Object.prototype object
                 *
                 * @name fitt.$obj
                 * @constant
                 * @public
                 * @type {Object}
                */

	exp.$obj = $obj;

	/**
                   * Shorthand for core JavaScript Array constructor
                   *
                   * @name fitt.ary
                   * @constant
                   * @public
                   * @type {Function}
                  */
	exp.ary = ary;

	/**
                 * Shorthand for core JavaScript Array.prototype object
                 *
                 * @name fitt.$ary
                 * @constant
                 * @public
                 * @type {Function}
                */

	exp.$ary = $ary;

	/**
                   * Shorthand for core JavaScript Function constructor
                   *
                   * @name fitt.func
                   * @constant
                   * @public
                   * @type {Function}
                  */

	exp.func = func;

	/**
                   * Shorthand for core JavaScript Function prototype object
                   *
                   * @name fitt.$func
                   * @constant
                   * @public
                   * @type {Object}
                  */

	exp.$func = $func;

	/**
                     * Shorthand for core JavaScript String constructor
                     *
                     * @name fitt.str
                     * @constant
                     * @public
                     * @type {Function}
                    */

	exp.str = str;

	/**
                 * Shorthand for core JavaScript String.prototype object
                 *
                 * @name fitt.$str
                 * @constant
                 * @public
                 * @type {Object}
                */

	exp.$str = $str;

	/**
                   * Whether or not the environment supports accessing characters of a string type via
                   * square bracket notation (e.g. str[2] rather than str.charAt(2))
                   *
                   * @name fitt.strArrayAccess
                   * @constant
                   * @public
                   * @type {Boolean}
                  */

	exp.strArrayAccess = strArrayAccess;

	/**
                                       * Shorthand for core JavaScript Number constructor
                                       *
                                       * @name fitt.num
                                       * @constant
                                       * @public
                                       * @type {Function}
                                      */

	exp.num = num;

	/**
                 * Shorthand for core JavaScript Number prototype object
                 *
                 * @name fitt.$num
                 * @constant
                 * @public
                 * @type {Object}
                */

	exp.$num = $num;

	/**
                   * Shorthand for core JavaScript Error constructor
                   *
                   * @name fitt.err
                   * @constant
                   * @public
                   * @type {Function}
                  */

	exp.err = err;

	/**
                 * Shorthand for core JavaScript Error prototype object.
                 *
                 * @name fitt.$err
                 * @constant
                 * @public
                 * @type {Object}
                */

	exp.$err = $err;

	/**
                   * Shorthand for core JavaScript RegExp constructor
                   * @name fitt.regex
                   * @constant
                   * @public
                   * @type {RegExp}
                  */

	exp.regx = regx;


	/**
                   * Shorthand for core JavaScript RegExp prototype object
                   *
                   * @name fitt.$regx
                   * @constant
                   * @public
                   * @type {Object}
                  */

	exp.$regx = $regx,


	/**
                     * Shorthand for core JavaScript Date object
                     * @constant
                     * @public
                     * @type {Date}
                    */

	exp.dte = dte;

	/**
                 * Shorthand for core JavaScript Date prototype object
                 * @constant
                 * @public
                 * @type {Object}
                */

	exp.$dte = $dte;

	/**
                   * Shorthand for core JavaScript Number.MAX_VALUE / largest safe
                   * integer value
                   * @name fitt.NUM_MAX
                   * @constant
                   * @public
                   * @type {Object}
                  */

	exp.NUM_MAX = NUM_MAX;

	/**
                        * Shorthand for core JavaScript Number.MIN_VALUE / smallest safe
                        * integer value (as in a negative version of NUM_MAX)
                        * @name fitt.NUM_MIN
                        * @constant
                        * @public
                        * @type {Object}
                        */

	exp.NUM_MIN = NUM_MIN;

	/*
                         * The remaining exported items need no further documenation
                         * as they were documented above
                        */

	exp.noop = noop;
	exp.passThru = passThru;
	exp.rtrue = rtrue;
	exp.rfalse = rfalse;
	exp.rnull = rnull;
	exp.rzero = rzero;
	exp.rone = rone;
	exp.isAry = isAry;
	exp.isAryLike = isAryLike;
	exp.isFunc = isFunc;
	exp.isObj = isObj;
	exp.isObjLike = isObjLike;
	exp.isDate = isDate;
	exp.isNum = isNum;
	exp.cnum = cnum;
	exp.cbool = cbool;
	exp.toStringTag = toStringTag;
	exp.cstr = cstr;
	exp.ord = ord;
	exp.strlc = strlc;
	exp.struc = struc;
	exp.strReplace = strReplace;
	exp.strMatch = strMatch;
	exp.trim = trim;
	exp.owns = owns;
	exp.empty = empty;
	exp.cobj = cobj;
	exp.cary = cary;
	exp.cprop = cprop;
	exp.cprops = cprops;
	exp.kindOf = kindOf;
	exp.gprop = obj_gprop;
	exp.gprops = obj_props;
	exp.forEach = forEach;
	exp.ns = ns;
	exp.mix = mix;
	exp.now = now;
	exp.gproto = obj_getProto;
	exp.sproto = obj_setProto;
	exp.noext = obj_noExtend;
	exp.canext = obj_canExtend;
	exp.frozen = obj_frozen;
	exp.sealed = obj_sealed;
	exp.seal = obj_seal;
	exp.freeze = obj_freeze;
	exp.props = obj_props;
	exp.keys = keys;
	exp.syms = obj_syms;
	exp.getGlobal = getGlobal;
	exp.isBrowser = isBrowser;
	exp.es = es;
	exp.ues = ues;
	exp.encdec = encodeDecode;
	exp.encURIComp = encURIComp;
	exp.decURIComp = decURIComp;
	exp.encURI = encURI;
	exp.decURI = decURI;
	exp.idxOf = idxOf;
	exp.subStr = subStr;
	exp.charAt = charAt;
	exp.regxTest = regxTest;
	exp.regxSearch = regxSearch;
	exp.canCall = canCall;
	exp.callSafe = callSafe;
	exp.inherits = inherits;
	exp.shallowEq = shallowEq;

	exp.PropDescErr = PropDescErr;
	exp.PropDesc = PropDesc;
	exp.DataPropDesc = DataPropDesc;
	exp.DynPropDesc = DynPropDesc;
	exp.MixOptions = MixOptions;

	return exp;
}();


(function () {

	var ret = fitt.mix({}, fitt, { noRecurse: true }),
	glob,globFitt;

	if (fitt.isBrowser()) {
		glob = fitt.getGlobal();
		globFitt = glob.fitt;

		if (!globFitt) {
			glob.fitt = ret;
		}
	}

	if (typeof module !== "undefined") {
		module.exports = ret;
	}
})();


//////////////////
// WEBPACK FOOTER
// ../~/espn-fitt/es5/fitt/fitt.js
// module id = 426
// module chunks = 0